



// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import {
//     Container,
//     Typography,
//     Button,
//     Box,
//     Stack,
//     Paper,
//     Snackbar,
//     Alert,
//     Chip,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     CircularProgress,
//     Tooltip,
//     IconButton,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     TextField,
//     List,
//     ListItem,
//     ListItemText,
//     ListItemIcon,
//     Divider
// } from '@mui/material';
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
// import { format, addDays, parseISO, startOfDay, isBefore, isToday, eachDayOfInterval, getMonth, getYear, startOfMonth, endOfMonth } from 'date-fns';
// import '../css/TrainingCalendarCustom.css';
// import './TrainingCalendarCustom.css';
// import CreateTrainingModal from './CreateTrainingModal';
// import TrainingDetailsModal from './TrainingDetailModal';
// import { createTrainingEntry, deleteTrainingEntry, fetchAllTraining, fetchTrainingsByMonth } from 'helpers/training_helper';
// import { toast } from 'react-toastify';
// import { fetchAllBatch } from 'helpers/batch_helper';
// import { fetchAllTrainers, getSingleUser, fetchAllUsers } from 'helpers/user_helper';
// import html2canvas from 'html2canvas';
// import { fetchCourseNames } from 'helpers/course_helper';
// import { useNavigate } from 'react-router-dom';
// import TwentyFourMpIcon from '@mui/icons-material/TwentyFourMp';
// import PrintIcon from '@mui/icons-material/Print';
// import ShareIcon from '@mui/icons-material/Share';
// import DownloadIcon from '@mui/icons-material/Download';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import CloseIcon from '@mui/icons-material/Close';
// import EmailIcon from '@mui/icons-material/Email';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import EmailCopyIcon from '@mui/icons-material/MailOutline';
// import jsPDF from 'jspdf';
// import html2pdf from 'html2pdf.js';
// import * as XLSX from 'xlsx';

// const TCalendar = ({ loader, setLoader }) => {
//     const [trainings, setTrainings] = useState([]);
//     const [selectedDateTrainings, setSelectedDateTrainings] = useState([]);
//     const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
//     const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
//     const [calendarDate, setCalendarDate] = useState(new Date());
//     const [selectedTrainingType, setSelectedTrainingType] = useState(null);
//     const [filteredTrainings, setFilteredTrainings] = useState([]);
//     const [selectedDepot, setSelectedDepot] = useState(null);
//     const [availableDepots, setAvailableDepots] = useState([]);
//     const [isDataLoading, setIsDataLoading] = useState(true);
//     const [isMonthLoading, setIsMonthLoading] = useState(false);
//     const [use24HourFormat, setUse24HourFormat] = useState(true);
//     const [shareDialogOpen, setShareDialogOpen] = useState(false);
//     const [shareUrl, setShareUrl] = useState('');
//     const [copyEmailDialogOpen, setCopyEmailDialogOpen] = useState(false);
//     const [emailBody, setEmailBody] = useState('');
//     const [loadedMonths, setLoadedMonths] = useState(new Map()); // Cache for loaded months
//     const [currentMonthKey, setCurrentMonthKey] = useState('');

//     const [snackbarOpen, setSnackbarOpen] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState('');
//     const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//     const [allBatch, setAllBatch] = useState([]);
//     const [allUsers, setAllUsers] = useState([]);
//     const [trainerMap, setTrainerMap] = useState(new Map());
//     const [allCourseNames, setAllCourseNames] = useState([]);
//     const [type, setType] = useState(null);
//     const [userPermissions, setUserPermissions] = useState({
//         canCreateTraining: false,
//         canDeleteTraining: false,
//         canGenerateBatch: false
//     });
    
//     const [userInfo, setUserInfo] = useState({
//         depot: null,
//         trainerId: null,
//         userName: null,
//         userId: null,
//         assignedDepot: null,
//         userType: null
//     });

//     const calendarRef = useRef(null);
//     const mainContainerRef = useRef(null);
//     const navigate = useNavigate();
//     const abortControllerRef = useRef(null);

//     const trainingTypes = [
//         { id: 1, name: "Safety", color: "#f44336", bgColor: "#ffebee" },
//         { id: 2, name: "IT", color: "#2196f3", bgColor: "#e3f2fd" },
//         { id: 3, name: "Technical", color: "#4caf50", bgColor: "#e8f5e9" },
//         { id: 4, name: "Driver", color: "#ff9800", bgColor: "#fff3e0" }
//     ];

//     const allDepotOptions = [
//         "BBM", "Backbay", "Bawana", "Bhagwati Nagar", "Deepanjali Nagar",
//         "Dichaon Kalan", "Dwarka-8", "GTK", "Hari Nagar-2", "Hasanpur",
//         "Hennur", "Indraprastha", "Jayanagar", "Jigani", "K R Puram",
//         "Kalkaji", "Kalinga Nagar", "Kannalli", "Malwani", "Mayapuri",
//         "Mera Mandali", "Mundela Kalan", "Nand Nagri", "Narela", "Naraina",
//         "Naranpura", "Nehru Place", "Okhla", "Online", "Pantnagar",
//         "Pantha Chowk", "Peenya", "Rohini-1", "Rohini-2", "Sarojini Nagar",
//         "Shanti Nagar", "Shivaji Nagar", "Subhash Place", "Sukhdev Vihar",
//         "Tekhand", "Tss", "Wazirpur", "Worli","Traffic Management Centre (TMC)","Vaddarahalli"
//     ];

//     // Helper function to get month key
//     const getMonthKey = (date) => {
//         return `${getYear(date)}-${String(getMonth(date) + 1).padStart(2, '0')}`;
//     };

//     // Helper function to get date range string for display (e.g., "16-20")
//     const getDateRangeString = (startDate, endDate) => {
//         if (!startDate || !endDate) return '';
//         try {
//             const start = new Date(startDate);
//             const end = new Date(endDate);
//             const startDay = format(start, 'd');
//             const endDay = format(end, 'd');
//             const startMonth = format(start, 'MMM');
//             const endMonth = format(end, 'MMM');
            
//             if (startMonth === endMonth) {
//                 return `${startDay}-${endDay} ${startMonth}`;
//             } else {
//                 return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
//             }
//         } catch (error) {
//             return '';
//         }
//     };

//     const isDateInPast = (dateString) => {
//         if (!dateString) return false;
//         const date = parseISO(dateString);
//         const today = startOfDay(new Date());
//         return isBefore(date, today) && !isToday(date);
//     };

//     const convertTo12HourFormat = (time24) => {
//         if (!time24) return '';
//         if (time24.includes('AM') || time24.includes('PM')) return time24;
        
//         const match = time24.match(/(\d{1,2}):(\d{2})/);
//         if (!match) return time24;
        
//         let hour = parseInt(match[1]);
//         const minute = match[2];
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         hour = hour % 12 || 12;
//         return `${hour}:${minute} ${ampm}`;
//     };

//     const convertTo24HourFormat = (time12) => {
//         if (!time12) return '';
//         if (time12.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) return time12;
        
//         const match = time12.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
//         if (!match) return time12;
        
//         let hour = parseInt(match[1]);
//         const minute = match[2];
//         const ampm = match[3].toUpperCase();
        
//         if (ampm === 'PM' && hour !== 12) hour += 12;
//         if (ampm === 'AM' && hour === 12) hour = 0;
        
//         return `${hour.toString().padStart(2, '0')}:${minute}`;
//     };

//     const formatTimeDisplay = (timeStr) => {
//         if (!timeStr) return '';
//         if (use24HourFormat) {
//             return convertTo24HourFormat(timeStr);
//         } else {
//             return convertTo12HourFormat(timeStr);
//         }
//     };

//     const calculateDuration = (startTime, endTime) => {
//         if (!startTime || !endTime) return 0;
//         try {
//             const parseTime = (timeStr) => {
//                 let hours = 0, minutes = 0;
//                 const isPM = timeStr.toLowerCase().includes('pm');
//                 const timeWithoutSuffix = timeStr.replace(/\s*[ap]m$/i, '').trim();
//                 const [hourStr, minuteStr] = timeWithoutSuffix.split(':');
//                 hours = parseInt(hourStr);
//                 minutes = parseInt(minuteStr) || 0;
//                 if (isPM && hours !== 12) hours += 12;
//                 if (!isPM && hours === 12) hours = 0;
//                 return { hours, minutes };
//             };
//             const start = parseTime(startTime);
//             const end = parseTime(endTime);
//             let totalMinutes = (end.hours * 60 + end.minutes) - (start.hours * 60 + start.minutes);
//             if (totalMinutes < 0) totalMinutes += 24 * 60;
//             return Math.round((totalMinutes / 60) * 10) / 10;
//         } catch (error) {
//             return 0;
//         }
//     };

//     const extractTimeFromType = (typeString) => {
//         if (!typeString) return null;
//         const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/gi;
//         const match = timePattern.exec(typeString);
//         if (match && match.length >= 3) {
//             return {
//                 startTime: match[1],
//                 endTime: match[2],
//                 fullTimeRange: `${formatTimeDisplay(match[1])} - ${formatTimeDisplay(match[2])}`
//             };
//         }
//         return null;
//     };

//     const extractDaysFromType = (typeString) => {
//         if (!typeString) return null;
//         const daysPattern = /-\s*(\d+)\s*(?:Day|Days|day|days)/i;
//         const match = daysPattern.exec(typeString);
//         if (match && match.length >= 2) {
//             return parseInt(match[1]);
//         }
//         return null;
//     };

//     const extractOriginalType = (typeString) => {
//         if (!typeString) return typeString;
//         const timePattern = /-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?\s*-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?$/i;
//         let typeWithoutTime = typeString.replace(timePattern, '').trim();
//         const daysPattern = /-\s*\d+\s*(?:Day|Days|day|days)\s*$/i;
//         typeWithoutTime = typeWithoutTime.replace(daysPattern, '').trim();
//         return typeWithoutTime.replace(/-\s*$/, '').trim();
//     };

//     const getTrainingTimeInfo = (training) => {
//         let startTime = '', endTime = '', duration = 0, timeDisplay = '';
        
//         if (training.startTime && training.endTime) {
//             startTime = training.startTime;
//             endTime = training.endTime;
//             const formattedStart = formatTimeDisplay(startTime);
//             const formattedEnd = formatTimeDisplay(endTime);
//             timeDisplay = `${formattedStart} - ${formattedEnd}`;
//             duration = calculateDuration(formattedStart, formattedEnd);
//         }
//         else if (training.type && typeof training.type === 'string') {
//             const timeFromType = extractTimeFromType(training.type);
//             if (timeFromType) {
//                 startTime = timeFromType.startTime;
//                 endTime = timeFromType.endTime;
//                 timeDisplay = timeFromType.fullTimeRange;
//                 duration = calculateDuration(formatTimeDisplay(startTime), formatTimeDisplay(endTime));
//             }
//         }
//         else if (training.timeSlotLabel) {
//             timeDisplay = training.timeSlotLabel;
//             const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/;
//             const match = timePattern.exec(timeDisplay);
//             if (match) {
//                 startTime = match[1];
//                 endTime = match[2];
//                 const formattedStart = formatTimeDisplay(startTime);
//                 const formattedEnd = formatTimeDisplay(endTime);
//                 timeDisplay = `${formattedStart} - ${formattedEnd}`;
//                 duration = calculateDuration(formattedStart, formattedEnd);
//             }
//         }
        
//         if (duration === 0 && training.duration) duration = training.duration;
//         if (!timeDisplay) timeDisplay = 'Time not specified';
        
//         return { startTime, endTime, timeDisplay, duration };
//     };

//     const getUserName = (userId, training = null) => {
//         if (training && training.trainerName && training.trainerName !== 'null' && training.trainerName !== 'undefined' && training.trainerName !== 'Not Assigned') {
//             return training.trainerName;
//         }
        
//         if (!userId) return 'Not Assigned';
        
//         const userIdNum = parseInt(userId);
        
//         if (trainerMap.has(userIdNum)) {
//             const mappedName = trainerMap.get(userIdNum);
//             if (mappedName && mappedName !== 'Not Assigned') {
//                 return mappedName;
//             }
//         }
        
//         const user = allUsers.find(u => parseInt(u.id) === userIdNum);
//         if (user) {
//             const userName = user.name || user.username || user.fullName || user.displayName || user.email?.split('@')[0] || 'User';
//             if (userName && userName !== 'User') {
//                 setTrainerMap(prev => new Map(prev).set(userIdNum, userName));
//                 return userName;
//             }
//         }
        
//         if (training && training.trainerName && training.trainerName !== 'null') {
//             return training.trainerName;
//         }
        
//         return 'Not Assigned';
//     };

//     useEffect(() => {
//         const authUser = JSON.parse(localStorage.getItem("authUser"));
//         if (authUser) {
//             const userType = authUser.userType || authUser.userTypeDto?.name;
//             setType(userType);
//             const userName = authUser.name || authUser.username || "User";
//             const userId = authUser.id || null;
            
//             const fetchUserDepot = async () => {
//                 if (userId && (userType === "Tata Depot Manager" || userType === "Tata Project Manager")) {
//                     try {
//                         const userData = await getSingleUser(userId);
//                         if (userData?.success && userData?.result?.[0]) {
//                             const userDetails = userData.result[0];
//                             let userAssignedDepot = null;
//                             if (userDetails.tataUserDetailsDto?.depot) {
//                                 userAssignedDepot = userDetails.tataUserDetailsDto.depot;
//                                 authUser.depot = userAssignedDepot;
//                                 localStorage.setItem("authUser", JSON.stringify(authUser));
//                             }
//                             setUserInfo({
//                                 depot: userAssignedDepot,
//                                 assignedDepot: userAssignedDepot,
//                                 trainerId: userId,
//                                 userName: userName,
//                                 userId: userId,
//                                 userType: userType
//                             });
//                             if (userAssignedDepot && userType === "Tata Depot Manager") {
//                                 setSelectedDepot(userAssignedDepot);
//                             }
//                         }
//                     } catch (error) {
//                         handleLocalStorageUser(authUser, userType, userName, userId);
//                     }
//                 } else {
//                     handleLocalStorageUser(authUser, userType, userName, userId);
//                 }
//             };
            
//             const handleLocalStorageUser = (authUser, userType, userName, userId) => {
//                 let userAssignedDepot = authUser.depot || authUser.tataUserDetailsDto?.depot || null;
//                 setUserInfo({
//                     depot: userAssignedDepot,
//                     assignedDepot: userAssignedDepot,
//                     trainerId: userId,
//                     userName: userName,
//                     userId: userId,
//                     userType: userType
//                 });
//                 if (userAssignedDepot && userType === "Tata Depot Manager") {
//                     setSelectedDepot(userAssignedDepot);
//                 }
//             };
            
//             fetchUserDepot();
            
//             setUserPermissions({
//                 canCreateTraining: ["Tata Project Manager", "Admin", "Super Admin"].includes(userType),
//                 canDeleteTraining: ["Tata Project Manager", "Admin", "Super Admin"].includes(userType),
//                 canGenerateBatch: ["Tata Project Manager", "Admin", "Super Admin", "Trainer"].includes(userType)
//             });
//         }
//     }, []);

//     const filterTrainingsByRole = (trainingsData) => {
//         if (!trainingsData || !type) return trainingsData;
//         let filtered = [...trainingsData];
        
//         if (type === "Tata Project Manager" && selectedDepot) {
//             filtered = filtered.filter(training => 
//                 training.depot?.trim().toLowerCase() === selectedDepot.trim().toLowerCase()
//             );
//         }
//         else if (type === "Tata Depot Manager" && selectedDepot) {
//             filtered = filtered.filter(training => 
//                 training.depot?.trim().toLowerCase() === selectedDepot.trim().toLowerCase()
//             );
//         }
//         else if (type === "Tata Depot Manager" && !selectedDepot) {
//             filtered = [];
//         }
//         else if (type === "Tata Trainer" && userInfo.trainerId) {
//             filtered = filtered.filter(training => {
//                 const trainingTrainerId = parseInt(training.trainerId);
//                 const currentTrainerId = parseInt(userInfo.trainerId);
//                 return trainingTrainerId === currentTrainerId;
//             });
//         }
        
//         const uniqueFiltered = [];
//         const seenIds = new Set();
//         for (const training of filtered) {
//             if (!seenIds.has(training.id)) {
//                 seenIds.add(training.id);
//                 uniqueFiltered.push(training);
//             }
//         }
        
//         return uniqueFiltered;
//     };

//     // Fetch trainings for a specific month
//     const fetchTrainingsForMonth = useCallback(async (date, forceRefresh = false) => {
//         const year = getYear(date);
//         const month = getMonth(date) + 1;
//         const monthKey = getMonthKey(date);
        
//         // Check if already loaded and not forcing refresh
//         if (!forceRefresh && loadedMonths.has(monthKey)) {
//             console.log(`Month ${monthKey} already loaded, using cache`);
//             const cachedTrainings = loadedMonths.get(monthKey);
//             setTrainings(cachedTrainings);
//             setFilteredTrainings(filterTrainingsByRole(cachedTrainings));
//             return cachedTrainings;
//         }
        
//         // Cancel previous request if any
//         if (abortControllerRef.current) {
//             abortControllerRef.current.abort();
//         }
        
//         abortControllerRef.current = new AbortController();
        
//         try {
//             setIsMonthLoading(true);
//             console.log(`Fetching trainings for ${monthKey}`);
            
//             const data = await fetchTrainingsByMonth(year, month);
            
//             if (data?.success && data?.result) {
//                 const uniqueTrainingsMap = new Map();
//                 data.result.forEach(training => {
//                     if (!uniqueTrainingsMap.has(training.id)) {
//                         uniqueTrainingsMap.set(training.id, training);
//                     }
//                 });
//                 const uniqueTrainings = Array.from(uniqueTrainingsMap.values());
                
//                 const formattedData = uniqueTrainings.map(training => {
//                     const startDate = new Date(training.trainingStartDate);
//                     const endDate = new Date(training.trainingEndDate);
//                     const timeInfo = getTrainingTimeInfo(training);
//                     const originalType = extractOriginalType(training.type);
//                     const daysFromType = extractDaysFromType(training.type);
                    
//                     let userName = 'Not Assigned';
//                     if (training.trainerName && training.trainerName !== 'null' && training.trainerName !== 'undefined') {
//                         userName = training.trainerName;
//                     } else if (training.trainerId) {
//                         userName = getUserName(training.trainerId, training);
//                     }
                    
//                     return {
//                         ...training,
//                         trainingStartDate: startDate,
//                         trainingEndDate: endDate,
//                         startTime: timeInfo.startTime,
//                         endTime: timeInfo.endTime,
//                         duration: timeInfo.duration,
//                         timeDisplay: timeInfo.timeDisplay,
//                         originalType: originalType || training.type,
//                         daysFromType: daysFromType,
//                         trainerName: userName,
//                         trainerDisplayName: userName,
//                         isPastDate: isDateInPast(training.trainingStartDate),
//                         isTechnicalTraining: training.type?.includes('Technical') || originalType?.includes('Technical'),
//                         technicalAssessmentType: training.technicalAssessmentType || '',
//                         allowPreviousDates: training.allowPreviousDates !== false,
//                         batchSchedule: training.batchSchedule || [],
//                         trainingDaysCount: training.trainingDaysCount || training.trainingDays || daysFromType,
//                         use24HourFormat: training.use24HourFormat !== undefined ? training.use24HourFormat : true,
//                         dateRange: getDateRangeString(training.trainingStartDate, training.trainingEndDate),
//                         trainingMode: training.trainingMode || null,
//                         batchPlan: training.batchPlan || null
//                     };
//                 });
                
//                 // Cache the loaded month
//                 setLoadedMonths(prev => new Map(prev).set(monthKey, formattedData));
                
//                 // Extract depots for filter
//                 const depots = [...new Set(formattedData.map(t => t.depot).filter(Boolean))];
//                 setAvailableDepots(depots.sort());
                
//                 setTrainings(formattedData);
//                 const roleFiltered = filterTrainingsByRole(formattedData);
//                 setFilteredTrainings(roleFiltered);
                
//                 return formattedData;
//             } else {
//                 // If no data, store empty array for this month
//                 setLoadedMonths(prev => new Map(prev).set(monthKey, []));
//                 setTrainings([]);
//                 setFilteredTrainings([]);
//                 return [];
//             }
//         } catch (error) {
//             if (error.name === 'AbortError') {
//                 console.log('Fetch aborted');
//                 return [];
//             }
//             console.error("Error fetching trainings for month:", error);
//             setSnackbarMessage('Failed to fetch trainings for this month.');
//             setSnackbarSeverity('error');
//             setSnackbarOpen(true);
//             return [];
//         } finally {
//             setIsMonthLoading(false);
//             if (setLoader) setLoader(false);
//         }
//     }, [loadedMonths, filterTrainingsByRole, setLoader, getUserName]);

//     // Load current month on mount
//     useEffect(() => {
//         const loadInitialData = async () => {
//             setIsDataLoading(true);
//             await getAllUsersData();
//             await getAllBatchesData();
//             await getAllCourseNamesData();
            
//             // Load current month
//             const currentDate = new Date();
//             setCalendarDate(currentDate);
//             await fetchTrainingsForMonth(currentDate, true);
            
//             setIsDataLoading(false);
//         };
//         loadInitialData();
//     }, []);

//     // Handle month change in calendar
//     const handleActiveStartDateChange = useCallback(async ({ activeStartDate }) => {
//         if (!activeStartDate) return;
        
//         const newDate = activeStartDate;
//         const currentMonth = getMonth(calendarDate);
//         const newMonth = getMonth(newDate);
        
//         // Only fetch if month changed
//         if (newMonth !== currentMonth || getYear(newDate) !== getYear(calendarDate)) {
//             setCalendarDate(newDate);
//             await fetchTrainingsForMonth(newDate);
//         }
//     }, [calendarDate, fetchTrainingsForMonth]);

//     useEffect(() => {
//         if (selectedTrainingType || selectedDepot) {
//             let filtered = [...trainings];
//             if (selectedTrainingType) {
//                 filtered = filtered.filter(training => 
//                     extractOriginalType(training.type) === selectedTrainingType.name
//                 );
//             }
//             const roleFiltered = filterTrainingsByRole(filtered);
//             setFilteredTrainings(roleFiltered);
//         } else {
//             setFilteredTrainings(filterTrainingsByRole(trainings));
//         }
//     }, [selectedTrainingType, selectedDepot, trainings, type, userInfo]);

//     const getAllBatchesData = async () => {
//         try {
//             const result = await fetchAllBatch();
//             if (result?.success) {
//                 setAllBatch(result?.result || []);
//             }
//         } catch (error) {
//             console.error("Error fetching batches:", error);
//             setAllBatch([]);
//         }
//     };

//     const getAllCourseNamesData = async () => {
//         try {
//             const result = await fetchCourseNames();
//             if (result?.success) {
//                 setAllCourseNames(result?.result || []);
//             }
//         } catch (error) {
//             console.error("Error fetching course names:", error);
//             setAllCourseNames([]);
//         }
//     };

//     const getAllUsersData = async () => {
//         try {
//             const data = await fetchAllUsers();
//             if (data?.success && data?.result) {
//                 setAllUsers(data.result);
//                 const map = new Map();
//                 data.result.forEach(user => {
//                     const userId = parseInt(user.id);
//                     const userName = user.name || user.username || user.fullName || user.displayName || user.email?.split('@')[0] || 'User';
//                     if (userName && userName !== 'User') {
//                         map.set(userId, userName);
//                     }
//                 });
//                 setTrainerMap(map);
//                 console.log("All users loaded:", data.result.length);
//             } else {
//                 const trainerData = await fetchAllTrainers();
//                 if (trainerData?.success && trainerData?.result) {
//                     setAllUsers(trainerData.result);
//                     const map = new Map();
//                     trainerData.result.forEach(user => {
//                         const userId = parseInt(user.id);
//                         const userName = user.name || user.username || user.fullName || 'Trainer';
//                         if (userName && userName !== 'Trainer') {
//                             map.set(userId, userName);
//                         }
//                     });
//                     setTrainerMap(map);
//                     console.log("Trainers loaded (fallback):", trainerData.result.length);
//                 } else {
//                     setAllUsers([]);
//                     setTrainerMap(new Map());
//                 }
//             }
//         } catch (error) {
//             console.error("Error fetching users:", error);
//             try {
//                 const trainerData = await fetchAllTrainers();
//                 if (trainerData?.success && trainerData?.result) {
//                     setAllUsers(trainerData.result);
//                     const map = new Map();
//                     trainerData.result.forEach(user => {
//                         const userId = parseInt(user.id);
//                         const userName = user.name || user.username || user.fullName || 'Trainer';
//                         map.set(userId, userName);
//                     });
//                     setTrainerMap(map);
//                 } else {
//                     setAllUsers([]);
//                     setTrainerMap(new Map());
//                 }
//             } catch (innerError) {
//                 console.error("Error fetching trainers fallback:", innerError);
//                 setAllUsers([]);
//                 setTrainerMap(new Map());
//             }
//         }
//     };

//     const createTraining = async (trainingData) => {
//         try {
//             if (setLoader) setLoader(true);
//             const formattedStartTime = formatTimeDisplay(trainingData.startTime);
//             const formattedEndTime = formatTimeDisplay(trainingData.endTime);
//             const calculatedDuration = calculateDuration(formattedStartTime, formattedEndTime);
            
//             const apiData = {
//                 name: trainingData.name,
//                 originalName: trainingData.originalName || trainingData.name,
//                 depot: trainingData.depot,
//                 type: trainingData.type,
//                 originalType: trainingData.originalType || extractOriginalType(trainingData.type),
//                 technicalAssessmentType: trainingData.technicalAssessmentType,
//                 state: trainingData.state,
//                 trainingStartDate: trainingData.trainingStartDate,
//                 trainingEndDate: trainingData.trainingEndDate,
//                 trainerId: trainingData.trainerId,
//                 trainerName: trainingData.trainerName,
//                 trainerEmail: trainingData.trainerEmail,
//                 trainerPhone: trainingData.trainerPhone,
//                 trainerType: trainingData.trainerType,
//                 trainingDays: trainingData.trainingDays,
//                 startTime: trainingData.startTime,
//                 endTime: trainingData.endTime,
//                 startHour: trainingData.startHour,
//                 endHour: trainingData.endHour,
//                 timeSlotLabel: trainingData.timeSlotLabel,
//                 timeSlotShortLabel: trainingData.timeSlotShortLabel,
//                 actualTrainingDays: trainingData.actualTrainingDays || trainingData.trainingDays,
//                 isTechnicalTraining: trainingData.isTechnicalTraining || false,
//                 isManualDateSelection: trainingData.isManualDateSelection || false,
//                 allowPreviousDates: trainingData.allowPreviousDates || true,
//                 batchSchedule: trainingData.batchSchedule || [],
//                 trainingDaysCount: trainingData.trainingDaysCount || trainingData.trainingDays,
//                 timeDisplay: `${formattedStartTime} - ${formattedEndTime}`,
//                 duration: calculatedDuration,
//                 use24HourFormat: trainingData.use24HourFormat !== undefined ? trainingData.use24HourFormat : true,
//                 trainingMode: trainingData.trainingMode || null,
//                 batchPlan: trainingData.batchPlan || null,
//                 courseId: trainingData.courseId || null,
//                 courseTitle: trainingData.courseTitle || trainingData.name
//             };
            
//             const startDate = new Date(trainingData.trainingStartDate);
//             const endDate = new Date(trainingData.trainingEndDate);
//             const [startHour, startMinute] = trainingData.startTime.split(':').map(Number);
//             startDate.setHours(startHour, startMinute || 0, 0, 0);
//             apiData.trainingStartDate = startDate.toISOString();
//             const [endHour, endMinute] = trainingData.endTime.split(':').map(Number);
//             endDate.setHours(endHour, endMinute || 0, 0, 0);
//             apiData.trainingEndDate = endDate.toISOString();
            
//             const data = await createTrainingEntry(apiData);
//             if (data.success) {
//                 // Refresh current month after creation
//                 await fetchTrainingsForMonth(calendarDate, true);
//                 setIsCreateModalOpen(false);
//                 setSnackbarMessage('Training created successfully!');
//                 setSnackbarSeverity('success');
//                 setSnackbarOpen(true);
//             } else {
//                 toast.error(data?.message || 'Failed to create training');
//             }
//         } catch (error) {
//             setSnackbarMessage(`Failed to create training: ${error.message}`);
//             setSnackbarSeverity('error');
//             setSnackbarOpen(true);
//         } finally {
//             if (setLoader) setLoader(false);
//         }
//     };

//     const deleteTraining = async (trainingId) => {
//         if (!window.confirm("Are you sure you want to delete this training?")) return;
//         try {
//             if (setLoader) setLoader(true);
//             const data = await deleteTrainingEntry(trainingId);
//             if (!data.success) throw new Error(data?.message);
//             // Refresh current month after deletion
//             await fetchTrainingsForMonth(calendarDate, true);
//             setIsDetailsModalOpen(false);
//             setSnackbarMessage('Training deleted successfully!');
//             setSnackbarSeverity('success');
//             setSnackbarOpen(true);
//         } catch (error) {
//             setSnackbarMessage(`Failed to delete training: ${error.message}`);
//             setSnackbarSeverity('error');
//             setSnackbarOpen(true);
//         } finally {
//             if (setLoader) setLoader(false);
//         }
//     };

//     const handleGenerateBatch = (training) => {
//         const timeInfo = getTrainingTimeInfo(training);
//         const batchData = {
//             batchName: `${training.name}_${format(new Date(training.trainingStartDate), 'yyyyMMdd')}`,
//             trainingId: training.id,
//             trainingName: training.name,
//             trainingType: training.originalType || extractOriginalType(training.type),
//             depot: training.depot,
//             state: training.state,
//             startDate: training.trainingStartDate,
//             endDate: training.trainingEndDate,
//             trainerId: training.trainerId,
//             trainingDays: training.trainingDays,
//             startTime: timeInfo.startTime,
//             endTime: timeInfo.endTime,
//             timeSlotLabel: timeInfo.timeDisplay,
//             batchSchedule: training.batchSchedule || [],
//             use24HourFormat: use24HourFormat,
//             trainingMode: training.trainingMode || null,
//             batchPlan: training.batchPlan || null
//         };
//         navigate('/all-batches', { state: { trainingData: batchData } });
//     };

//     useEffect(() => {
//         if (allUsers.length > 0 && trainings.length > 0) {
//             const updatedTrainings = trainings.map(training => {
//                 let userName = training.trainerName;
//                 if ((!userName || userName === 'Not Assigned') && training.trainerId) {
//                     userName = getUserName(training.trainerId, training);
//                 }
//                 return {
//                     ...training,
//                     trainerName: userName,
//                     trainerDisplayName: userName
//                 };
//             });
//             setTrainings(updatedTrainings);
//             setFilteredTrainings(prev => prev.map(t => {
//                 let userName = t.trainerName;
//                 if ((!userName || userName === 'Not Assigned') && t.trainerId) {
//                     userName = getUserName(t.trainerId, t);
//                 }
//                 return {
//                     ...t,
//                     trainerName: userName,
//                     trainerDisplayName: userName
//                 };
//             }));
//         }
//     }, [allUsers]);

//     const isTrainingOnDate = (training, date) => {
//         if (!training.trainingStartDate || !training.trainingEndDate) return false;
        
//         const checkDate = new Date(date);
//         checkDate.setHours(0, 0, 0, 0);
        
//         const startDate = new Date(training.trainingStartDate);
//         startDate.setHours(0, 0, 0, 0);
        
//         const endDate = new Date(training.trainingEndDate);
//         endDate.setHours(0, 0, 0, 0);
        
//         return checkDate >= startDate && checkDate <= endDate;
//     };

//     const handleDateClick = (date) => {
//         const trainingsOnDate = filteredTrainings.filter(training => 
//             isTrainingOnDate(training, date)
//         );
//         setSelectedDateTrainings(trainingsOnDate);
//         setIsDetailsModalOpen(true);
//     };

//     const isWeekend = (date) => {
//         const day = date.getDay();
//         return day === 0 || day === 6;
//     };

//     // Get trainings for current month only
//     const getCurrentMonthTrainings = useCallback(() => {
//         const currentMonth = getMonth(calendarDate);
//         const currentYear = getYear(calendarDate);
//         return filteredTrainings.filter(training => {
//             const startMonth = getMonth(new Date(training.trainingStartDate));
//             const startYear = getYear(new Date(training.trainingStartDate));
//             return startMonth === currentMonth && startYear === currentYear;
//         });
//     }, [filteredTrainings, calendarDate]);

//     const TrainingCard = ({ training, onClick, isForDownload = false }) => {
//         let userName = training.trainerDisplayName || training.trainerName;
//         if (!userName || userName === 'Not Assigned') {
//             if (training.trainerId) {
//                 userName = getUserName(training.trainerId, training);
//             } else {
//                 userName = 'Not Assigned';
//             }
//         }
        
//         const originalTypeValue = training.originalType || extractOriginalType(training.type);
//         const isPastDate = training.isPastDate || isDateInPast(training.trainingStartDate);
//         const timeInfo = getTrainingTimeInfo(training);
//         const trainingType = trainingTypes.find(t => t.name === originalTypeValue) || trainingTypes[0];
//         const dateRange = training.dateRange || getDateRangeString(training.trainingStartDate, training.trainingEndDate);
        
//         const cardStyles = {
//             backgroundColor: trainingType.bgColor,
//             borderLeft: `4px solid ${trainingType.color}`,
//             border: `1px solid ${trainingType.color}40`,
//             borderRadius: "4px",
//             padding: isForDownload ? "10px" : "8px",
//             marginBottom: "8px",
//             fontSize: isForDownload ? "12px" : "0.7rem",
//             lineHeight: 1.5,
//             position: 'relative',
//             wordBreak: 'break-word',
//             whiteSpace: 'normal',
//             overflow: 'visible',
//             color: '#000000',
//             ...(!isForDownload && {
//                 cursor: 'pointer',
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                     transform: 'scale(1.02)',
//                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                 }
//             })
//         };
        
//         return (
//             <Box 
//                 key={`training-card-${training.id}`} 
//                 onClick={!isForDownload ? onClick : undefined} 
//                 sx={cardStyles}
//             >
//                 {isPastDate && !isForDownload && (
//                     <Box sx={{
//                         position: 'absolute',
//                         top: 2,
//                         right: 2,
//                         bgcolor: '#ff9800',
//                         color: 'white',
//                         fontSize: "0.5rem",
//                         px: 0.5,
//                         py: 0.2,
//                         borderRadius: "2px"
//                     }}>
//                         PAST
//                     </Box>
//                 )}
                
//                 <Typography fontWeight="bold" sx={{ 
//                     fontSize: isForDownload ? "13px" : "0.75rem", 
//                     mb: 0.5, 
//                     wordBreak: 'break-word', 
//                     pr: 3,
//                     color: '#000000'
//                 }}>
//                     {training.name || 'Unnamed Training'}
//                 </Typography>

//                 {/* Date Range Display - Shows (16-20) format */}
//                 {dateRange && (
//                     <Typography sx={{ 
//                         fontSize: isForDownload ? "11px" : "0.6rem", 
//                         mb: 0.3, 
//                         color: '#1976d2', 
//                         fontWeight: 600,
//                         wordBreak: 'break-word'
//                     }}>
//                         📅 {dateRange}
//                     </Typography>
//                 )}
                
//                 <Typography sx={{ 
//                     fontSize: isForDownload ? "11px" : "0.65rem", 
//                     mb: 0.3, 
//                     color: '#000000',
//                     wordBreak: 'break-word' 
//                 }}>
//                     📍 {training.depot}
//                 </Typography>
                
//                 <Typography sx={{ 
//                     fontSize: isForDownload ? "11px" : "0.65rem", 
//                     mb: 0.3, 
//                     color: '#000000',
//                     wordBreak: 'break-word' 
//                 }}>
//                     📍 {training.state}
//                 </Typography>
                
//                 <Typography sx={{ 
//                     fontSize: isForDownload ? "11px" : "0.65rem", 
//                     mb: 0.3, 
//                     color: '#000000',
//                     fontWeight: 500, 
//                     wordBreak: 'break-word' 
//                 }}>
//                     👨‍🏫 {userName}
//                 </Typography>
                
//                 {timeInfo.timeDisplay && timeInfo.timeDisplay !== 'Time not specified' && (
//                     <Typography sx={{ 
//                         fontSize: isForDownload ? "11px" : "0.65rem", 
//                         mb: 0.3, 
//                         color: '#000000',
//                         wordBreak: 'break-word' 
//                     }}>
//                         ⏰ {timeInfo.timeDisplay} {timeInfo.duration > 0 && `(${timeInfo.duration}hr)`}
//                     </Typography>
//                 )}
                
//                 {/* Display Training Mode and Batch Plan from backend */}
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
//                     {training.trainingMode ? (
//                         <Chip 
//                             label={`📋 ${training.trainingMode}`} 
//                             size="small" 
//                             variant="outlined"
//                             color="info"
//                             sx={{ fontSize: '0.55rem', height: 20 }}
//                         />
//                     ) : (
//                         <Chip 
//                             label="📋 N/A" 
//                             size="small" 
//                             variant="outlined"
//                             color="default"
//                             sx={{ fontSize: '0.55rem', height: 20 }}
//                         />
//                     )}
//                     {training.batchPlan ? (
//                         <Chip 
//                             label={`📊 Plan: ${training.batchPlan}`} 
//                             size="small" 
//                             variant="outlined"
//                             color="secondary"
//                             sx={{ fontSize: '0.55rem', height: 20 }}
//                         />
//                     ) : (
//                         <Chip 
//                             label="📊 Plan: N/A" 
//                             size="small" 
//                             variant="outlined"
//                             color="default"
//                             sx={{ fontSize: '0.55rem', height: 20 }}
//                         />
//                     )}
//                 </Box>
                
//                 <Box sx={{
//                     display: 'inline-block',
//                     backgroundColor: trainingType.color,
//                     color: 'white',
//                     padding: "4px 10px",
//                     borderRadius: "16px",
//                     fontSize: isForDownload ? "10px" : "0.6rem",
//                     fontWeight: "bold",
//                     marginTop: "6px"
//                 }}>
//                     {originalTypeValue}
//                 </Box>
//             </Box>
//         );
//     };

//     const tileContent = ({ date, view }) => {
//         if (view !== "month") return null;
        
//         const currentMonth = calendarDate.getMonth();
//         const currentYear = calendarDate.getFullYear();
//         if (date.getMonth() !== currentMonth || date.getFullYear() !== currentYear) return null;
        
//         const trainingsMap = new Map();
//         filteredTrainings.forEach(training => {
//             if (isTrainingOnDate(training, date)) {
//                 if (!trainingsMap.has(training.id)) {
//                     trainingsMap.set(training.id, training);
//                 }
//             }
//         });
        
//         const trainingsOnDate = Array.from(trainingsMap.values());
        
//         if (trainingsOnDate.length === 0) return null;
        
//         const sortedTrainings = [...trainingsOnDate].sort((a, b) => 
//             (a.name || '').localeCompare(b.name || '')
//         );
        
//         return (
//             <Box sx={{ 
//                 mt: 1,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '6px'
//             }}>
//                 {sortedTrainings.map((training) => (
//                     <TrainingCard 
//                         key={`${training.id}-${format(date, 'yyyy-MM-dd')}`}
//                         training={training}
//                         onClick={() => handleDateClick(date)}
//                         isForDownload={false}
//                     />
//                 ))}
//             </Box>
//         );
//     };

//     const toggleTimeFormat = () => {
//         setUse24HourFormat(!use24HourFormat);
//         // Refresh current month with new time format
//         setTimeout(() => {
//             fetchTrainingsForMonth(calendarDate, true);
//         }, 100);
//     };

//     const getMonthlyStats = useCallback(() => {
//         // Get only current month trainings
//         const currentMonthTrainings = getCurrentMonthTrainings();
//         const total = currentMonthTrainings.length;
//         const driverTrainings = currentMonthTrainings.filter(t => 
//             (t.originalType || extractOriginalType(t.type)) === 'Driver'
//         ).length;
//         const technicalTrainings = currentMonthTrainings.filter(t => 
//             (t.originalType || extractOriginalType(t.type)) === 'Technical'
//         ).length;
//         const safetyTrainings = currentMonthTrainings.filter(t => 
//             (t.originalType || extractOriginalType(t.type)) === 'Safety'
//         ).length;
//         const itTrainings = currentMonthTrainings.filter(t => 
//             (t.originalType || extractOriginalType(t.type)) === 'IT'
//         ).length;
        
//         return { total, driverTrainings, technicalTrainings, safetyTrainings, itTrainings };
//     }, [getCurrentMonthTrainings]);

//     const generateEmailHTML = useCallback(() => {
//         const stats = getMonthlyStats();

//         const currentDate = calendarDate;
//         const year = currentDate.getFullYear();
//         const month = currentDate.getMonth();
//         const firstDayOfMonth = new Date(year, month, 1);
//         const lastDayOfMonth = new Date(year, month + 1, 0);
//         const startDayOfWeek = firstDayOfMonth.getDay();
//         const daysInMonth = lastDayOfMonth.getDate();
//         const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//         const shortWeekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        
//         let calendarHTML = '<table style="width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; font-size: 11px; table-layout: fixed;">';
//         calendarHTML += '<thead><tr style="background: #f5f5f5; position: sticky; top: 0; z-index: 10;">';
//         weekdays.forEach(day => {
//             calendarHTML += `<th style="padding: 8px; border: 1px solid #ddd; text-align: center; font-size: 11px; background: #f5f5f5; position: sticky; top: 0; z-index: 10; width: 14.28%;">${day.slice(0, 3)}</th>`;
//         });
//         calendarHTML += '</tr></thead><tbody><tr>';
        
//         for (let i = 0; i < startDayOfWeek; i++) {
//             calendarHTML += `<td style="padding: 4px; border: 1px solid #ddd; vertical-align: top; min-height: 200px; background: #fafafa; width: 14.28%;">&nbsp;</td>`;
//         }
        
//         for (let day = 1; day <= daysInMonth; day++) {
//             const date = new Date(year, month, day);
//             const isWeekendDay = date.getDay() === 0 || date.getDay() === 6;
//             const trainingsOnDate = filteredTrainings.filter(training => isTrainingOnDate(training, date));
//             const dayOfWeek = shortWeekdays[date.getDay()];
            
//             calendarHTML += `
//                 <td style="padding: 4px; border: 1px solid #ddd; vertical-align: top; min-height: 200px; ${isWeekendDay ? 'background: #fff8e1;' : 'background: white;'} width: 14.28%;">
//                     <div style="position: sticky; top: 38px; background: ${isWeekendDay ? '#fff8e1' : 'white'}; z-index: 5; padding: 4px 0; border-bottom: 2px solid #1976d2; margin-bottom: 6px;">
//                         <strong style="font-size: 13px; display: inline-block; ${isWeekendDay ? 'color: #0a0a0a;' : 'color: #1976d2;'}">
//                             ${day} ${dayOfWeek}
//                         </strong>
//                         ${trainingsOnDate.length > 0 ? `<span style="font-size: 10px; color: #666; margin-left: 6px;">(${trainingsOnDate.length})</span>` : ''}
//                     </div>
//                     <div style="margin-top: 3px; max-height: 500px; overflow-y: auto;">
//                         ${trainingsOnDate.map((training, index) => {
//                             let userName = training.trainerDisplayName || training.trainerName;
//                             if (!userName || userName === 'Not Assigned') {
//                                 if (training.trainerId) {
//                                     const userIdNum = parseInt(training.trainerId);
//                                     if (trainerMap.has(userIdNum)) {
//                                         userName = trainerMap.get(userIdNum);
//                                     } else {
//                                         const user = allUsers.find(u => parseInt(u.id) === userIdNum);
//                                         if (user) {
//                                             userName = user.name || user.username || user.fullName || user.displayName || user.email?.split('@')[0] || 'Not Assigned';
//                                         } else {
//                                             userName = 'Not Assigned';
//                                         }
//                                     }
//                                 } else {
//                                     userName = 'Not Assigned';
//                                 }
//                             }
                            
//                             const originalTypeValue = training.originalType || extractOriginalType(training.type);
//                             const timeInfo = getTrainingTimeInfo(training);
//                             const trainingType = trainingTypes.find(t => t.name === originalTypeValue) || trainingTypes[0];
//                             const dateRange = training.dateRange || getDateRangeString(training.trainingStartDate, training.trainingEndDate);
                            
//                             return `
//                                 <div style="background: ${trainingType.bgColor}; border: 2px solid ${trainingType.color}; border-radius: 4px; padding: 6px 8px; margin-bottom: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.08); min-height: 120px; height: auto; display: flex; flex-direction: column; position: relative; color: #000000;">
//                                     ${index > 0 ? `<div style="border-top: 2px dashed #ccc; margin: -2px -8px 6px -8px; padding-top: 6px;"></div>` : ''}
//                                     <strong style="font-size: 11px; display: block; margin-bottom: 3px; color: #000000; line-height: 1.3; min-height: 28px;">${escapeHtml(training.name || 'Unnamed Training')}</strong>
//                                     ${dateRange ? `<div style="font-size: 9px; color: #1976d2; font-weight: 600; margin-bottom: 2px;">📅 ${escapeHtml(dateRange)}</div>` : ''}
//                                     <div style="font-size: 9px; color: #000000; margin-bottom: 1px; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">📍 ${escapeHtml(training.depot || 'N/A')}</div>
//                                     <div style="font-size: 9px; color: #000000; margin-bottom: 1px; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">📍 ${escapeHtml(training.state || 'N/A')}</div>
//                                     <div style="font-size: 9px; color: #000000; margin-bottom: 1px; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">👨‍🏫 ${escapeHtml(userName)}</div>
//                                     ${timeInfo.timeDisplay && timeInfo.timeDisplay !== 'Time not specified' ? `<div style="font-size: 9px; color: #000000; margin-bottom: 1px; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">⏰ ${escapeHtml(timeInfo.timeDisplay)} ${timeInfo.duration > 0 ? `(${timeInfo.duration}hr)` : ''}</div>` : ''}
//                                     ${training.trainingMode ? `<div style="font-size: 8px; color: #666; margin-top: 2px;">📋 Mode: ${escapeHtml(training.trainingMode)}</div>` : `<div style="font-size: 8px; color: #999; margin-top: 2px;">📋 Mode: N/A</div>`}
//                                     ${training.batchPlan ? `<div style="font-size: 8px; color: #666;">📊 Plan: ${escapeHtml(training.batchPlan)}</div>` : `<div style="font-size: 8px; color: #999;">📊 Plan: N/A</div>`}
//                                     <span style="background: ${trainingType.color}; color: white; padding: 1px 8px; border-radius: 10px; font-size: 8px; display: inline-block; margin-top: auto; align-self: flex-start; font-weight: bold;">${escapeHtml(originalTypeValue)}</span>
//                                 </div>
//                                 ${index < trainingsOnDate.length - 1 ? `
//                                 <hr style="border:none; border-top:3px dashed #1976d2; margin:15px 0;"></hr>` : ''}
//                             `;
//                         }).join('')}
//                     </div>
//                 </td>
//             `;
            
//             if ((startDayOfWeek + day) % 7 === 0 && day !== daysInMonth) {
//                 calendarHTML += '</tr><tr>';
//             }
//         }
        
//         const totalCells = startDayOfWeek + daysInMonth;
//         const remainingCells = (7 - (totalCells % 7)) % 7;
//         for (let i = 0; i < remainingCells; i++) {
//             calendarHTML += `<td style="padding: 4px; border: 1px solid #8a8484; vertical-align: top; min-height: 200px; background: #faf7f7; width: 14.28%;">&nbsp;</td>`;
//         }
        
//         calendarHTML += '</tr></tbody></table>';
        
//         return `<!DOCTYPE html>
// <html>
// <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>Training Calendar - ${format(calendarDate, 'MMMM yyyy')}</title>
//     <style>
//         body { font-family: Arial, sans-serif; margin: 0; padding: 10px; background: #f5f5f5; }
//         .container { max-width: 100%; margin: 0 auto; background: white; border-radius: 6px; padding: 15px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
//         h1 { color: #1976d2; text-align: center; margin-bottom: 15px; font-size: 20px; }
//         .header-info { display: flex; justify-content: space-between; margin-bottom: 15px; padding: 10px; background: #f5f5f5; border-radius: 6px; flex-wrap: wrap; gap: 8px; font-size: 11px; }
//         .stats-container { display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 15px; padding: 12px; background: #e3f2fd; border-radius: 6px; border-left: 4px solid #1976d2; }
//         .stat-item { display: flex; align-items: center; gap: 6px; font-size: 12px; }
//         .stat-number { font-weight: bold; color: #1976d2; font-size: 16px; }
//         .legend { margin-bottom: 15px; padding: 10px; background: #fafafa; border-radius: 6px; font-size: 11px; }
//         .legend-items { display: flex; gap: 15px; flex-wrap: wrap; margin-top: 6px; }
//         .legend-item { display: flex; align-items: center; gap: 6px; font-size: 11px; }
//         .legend-color { width: 14px; height: 14px; border-radius: 3px; }
//         .alert-info { background: #e3f2fd; padding: 10px; border-radius: 6px; margin-bottom: 15px; border-left: 4px solid #2196f3; font-size: 11px; }
//         .footer { margin-top: 20px; text-align: center; font-size: 10px; color: #666; padding: 10px; border-top: 1px solid #e0e0e0; }
//         .training-box { 
//             background: white; 
//             border: 2px solid #ddd; 
//             border-radius: 4px; 
//             padding: 6px 8px; 
//             margin-bottom: 6px;
//             box-shadow: 0 1px 2px rgba(0,0,0,0.08);
//             min-height: 120px;
//             height: auto;
//             display: flex;
//             flex-direction: column;
//             position: relative;
//             color: #000000;
//         }
//         .training-separator {
//             border-top: 2px dashed #ccc;
//             margin: -2px -8px 6px -8px;
//             padding-top: 6px;
//         }
//         .training-name { 
//             font-size: 11px; 
//             font-weight: bold; 
//             display: block; 
//             margin-bottom: 3px; 
//             color: #000000; 
//             line-height: 1.3;
//             min-height: 28px;
//         }
//         .training-detail { 
//             font-size: 9px; 
//             margin-bottom: 1px; 
//             line-height: 1.3;
//             white-space: nowrap;
//             overflow: hidden;
//             text-overflow: ellipsis;
//             color: #000000;
//         }
//         .training-type-badge {
//             padding: 1px 8px;
//             border-radius: 10px;
//             font-size: 8px;
//             display: inline-block;
//             margin-top: auto;
//             align-self: flex-start;
//             font-weight: bold;
//             color: white;
//         }
//         .date-header {
//             position: sticky;
//             top: 38px;
//             background: white;
//             z-index: 5;
//             padding: 4px 0;
//             border-bottom: 2px solid #1976d2;
//             margin-bottom: 6px;
//         }
//         .calendar-table th {
//             position: sticky;
//             top: 0;
//             z-index: 10;
//             background: #f5f5f5;
//         }
//         table { table-layout: fixed; }
//         td { width: 14.28%; }
//         .date-range-badge {
//             font-size: 9px;
//             color: #1976d2;
//             font-weight: 600;
//             margin-top: 2px;
//         }
//         .training-card-text {
//             color: #000000 !important;
//         }
//         .training-mode-badge {
//             font-size: 8px;
//             color: #666;
//             margin-top: 2px;
//         }
//         .training-plan-badge {
//             font-size: 8px;
//             color: #666;
//         }
//         @media only screen and (max-width: 600px) {
//             .container { padding: 8px; }
//             td { padding: 2px !important; }
//             .stat-item { font-size: 10px; }
//             .training-box { padding: 4px 6px; min-height: 100px; }
//             .training-name { font-size: 10px; min-height: 24px; }
//             .training-detail { font-size: 8px; }
//         }
//         @media print {
//             body { background: white; padding: 0; }
//             .container { box-shadow: none; }
//         }
//     </style>
// </head>
// <body>
//     <div class="container">
//         <h1>📅 Training Calendar</h1>
//         <div class="header-info">
//             <div><strong>Generated:</strong> ${new Date().toLocaleString()}</div>
//             <div><strong>Month:</strong> ${format(calendarDate, 'MMMM yyyy')}</div>
//             <div><strong>Role:</strong> ${type || 'Guest'}</div>
//             <div><strong>Time Format:</strong> ${use24HourFormat ? '24-Hour' : '12-Hour'}</div>
//         </div>
        
//         <div class="stats-container">
//             <div class="stat-item">📊 <span class="stat-number">${stats.total}</span> Total Trainings (${format(calendarDate, 'MMMM')})</div>
//             <div class="stat-item">🚗 <span class="stat-number">${stats.driverTrainings}</span> Driver Trainings</div>
//             <div class="stat-item">💻 <span class="stat-number">${stats.technicalTrainings}</span> Technical Trainings</div>
//             <div class="stat-item">🛡️ <span class="stat-number">${stats.safetyTrainings}</span> Safety Trainings</div>
//             <div class="stat-item">🔷 <span class="stat-number">${stats.itTrainings}</span> IT Trainings</div>
//         </div>
        
//         <div class="legend">
//             <strong>📌 Training Types Legend:</strong>
//             <div class="legend-items">
//                 ${trainingTypes.map(type => `
//                     <div class="legend-item">
//                         <div class="legend-color" style="background-color: ${type.color};"></div>
//                         <span>${type.name}</span>
//                     </div>
//                 `).join('')}
//             </div>
//         </div>
        
//         <div class="alert-info">
//             <strong>ℹ️ Calendar Information:</strong> Displays a total of ${filteredTrainings.length} training batches scheduled from April 2026 to the ${format(calendarDate, 'MMMM yyyy')}.
//             <br />
//             <strong>📌 Separator Lines:</strong> Each date provides a comprehensive view of all scheduled training sessions, including batch details, trainer information, and other relevant training particulars.
//             <br />
//             <strong>⚫ Training Names:</strong> All training names and details are displayed in black text for better readability.
//             <br />
//             <strong>📋 Training Mode & Batch Plan:</strong> Each training card now displays the training mode and batch plan number. If not available, shows "N/A".
//         </div>
        
//         <h3 style="margin: 15px 0 10px 0; color: #333; font-size: 16px;">📆 Calendar View</h3>
//         <div style="overflow-x: auto;">
//             ${calendarHTML}
//         </div>
        
//         <div class="footer">
//             Generated on ${new Date().toLocaleString()} | Training Management System
//         </div>
//     </div>
// </body>
// </html>`;
//     }, [calendarDate, filteredTrainings, getMonthlyStats, type, use24HourFormat, trainerMap, allUsers]);

//     const handleCopyToEmail = () => {
//         const emailHTML = generateEmailHTML();
//         setEmailBody(emailHTML);
//         setCopyEmailDialogOpen(true);
//     };

//     const copyToClipboardEmail = async () => {
//         try {
//             const blob = new Blob([emailBody], { type: 'text/html' });
            
//             if (navigator.clipboard && navigator.clipboard.write) {
//                 const clipboardItem = new ClipboardItem({
//                     'text/html': blob,
//                     'text/plain': new Blob([stripHtml(emailBody)], { type: 'text/plain' })
//                 });
//                 await navigator.clipboard.write([clipboardItem]);
//             } else {
//                 await navigator.clipboard.writeText(stripHtml(emailBody));
//             }
            
//             setSnackbarMessage('Calendar copied to clipboard! Paste directly into Gmail/Outlook (Ctrl+V)');
//             setSnackbarSeverity('success');
//             setSnackbarOpen(true);
//             setCopyEmailDialogOpen(false);
//         } catch (err) {
//             console.error("Copy failed:", err);
//             navigator.clipboard.writeText(stripHtml(emailBody));
//             setSnackbarMessage('Calendar copied as text. Paste into your email.');
//             setSnackbarSeverity('success');
//             setSnackbarOpen(true);
//             setCopyEmailDialogOpen(false);
//         }
//     };

//     const stripHtml = (html) => {
//         const tmp = document.createElement('div');
//         tmp.innerHTML = html;
//         return tmp.textContent || tmp.innerText || '';
//     };

//     const openEmailClient = () => {
//         const subject = `Training Calendar - ${format(calendarDate, 'MMMM yyyy')}`;
//         const body = stripHtml(emailBody);
//         window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
//         setCopyEmailDialogOpen(false);
//     };

//     const handlePrint = () => {
//         const printWindow = window.open('', '_blank');
//         printWindow.document.write(generateEmailHTML());
//         printWindow.document.close();
//         printWindow.print();
//     };

//     const handleExportPDF = async () => {
//         try {
//             toast.info("Generating PDF...");
//             const element = document.createElement('div');
//             element.innerHTML = generateEmailHTML();
//             document.body.appendChild(element);
//             const opt = {
//                 margin: [0.5, 0.5, 0.5, 0.5],
//                 filename: `training_calendar_${format(calendarDate, 'yyyy_MM')}.pdf`,
//                 image: { type: 'jpeg', quality: 0.98 },
//                 html2canvas: { scale: 2, useCORS: true },
//                 jsPDF: { unit: 'in', format: 'a2', orientation: 'landscape' }
//             };
//             html2pdf().set(opt).from(element).save();
//             document.body.removeChild(element);
//             toast.success('PDF exported successfully!');
//         } catch (error) {
//             console.error("PDF export failed:", error);
//             toast.error('Failed to export PDF');
//         }
//     };

//     const handleExportExcel = () => {
//         try {
//             const stats = getMonthlyStats();
            
//             const summaryData = [
//                 ['Training Calendar Summary - ' + format(calendarDate, 'MMMM yyyy')],
//                 [''],
//                 ['Monthly Statistics (' + format(calendarDate, 'MMMM') + '):'],
//                 ['Total Trainings', stats.total],
//                 ['Driver Trainings', stats.driverTrainings],
//                 ['Technical Trainings', stats.technicalTrainings],
//                 ['Safety Trainings', stats.safetyTrainings],
//                 ['IT Trainings', stats.itTrainings],
//                 [''],
//                 ['Generated on:', new Date().toLocaleString()],
//                 ['Role:', type || 'Guest'],
//                 ['Time Format:', use24HourFormat ? '24-Hour' : '12-Hour']
//             ];
            
//             const trainingData = filteredTrainings.map(training => {
//                 const timeInfo = getTrainingTimeInfo(training);
                
//                 let userName = training.trainerDisplayName || training.trainerName;
//                 if (!userName || userName === 'Not Assigned') {
//                     if (training.trainerId) {
//                         const userIdNum = parseInt(training.trainerId);
//                         if (trainerMap.has(userIdNum)) {
//                             userName = trainerMap.get(userIdNum);
//                         } else {
//                             const user = allUsers.find(u => parseInt(u.id) === userIdNum);
//                             if (user) {
//                                 userName = user.name || user.username || user.fullName || user.displayName || user.email?.split('@')[0] || 'Not Assigned';
//                             } else {
//                                 userName = 'Not Assigned';
//                             }
//                         }
//                     } else {
//                         userName = 'Not Assigned';
//                     }
//                 }
                
//                 const startDateStr = format(new Date(training.trainingStartDate), 'dd/MM/yyyy');
//                 const endDateStr = format(new Date(training.trainingEndDate), 'dd/MM/yyyy');
//                 const dateRange = training.dateRange || getDateRangeString(training.trainingStartDate, training.trainingEndDate);
                
//                 return {
//                     'Training Name': training.name || '-',
//                     'Training Type': training.originalType || extractOriginalType(training.type),
//                     'Date Range': dateRange || '-',
//                     'Start Date': startDateStr,
//                     'End Date': endDateStr,
//                     'Depot': training.depot || '-',
//                     'State': training.state || '-',
//                     'Trainer': userName,
//                     'Time': timeInfo.timeDisplay,
//                     'Duration (Hours)': timeInfo.duration > 0 ? timeInfo.duration : '-',
//                     'Status': isDateInPast(training.trainingStartDate) ? 'Past' : 'Upcoming',
//                     'Training Mode': training.trainingMode || 'N/A',
//                     'Batch Plan': training.batchPlan || 'N/A'
//                 };
//             });
            
//             const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
//             const wsTrainings = XLSX.utils.json_to_sheet(trainingData);
//             wsTrainings['!cols'] = [
//                 { wch: 30 }, { wch: 15 }, { wch: 15 }, { wch: 12 },
//                 { wch: 12 }, { wch: 20 }, { wch: 15 }, { wch: 25 },
//                 { wch: 20 }, { wch: 15 }, { wch: 10 }, { wch: 15 },
//                 { wch: 12 }
//             ];
            
//             const wb = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(wb, wsSummary, 'Summary');
//             XLSX.utils.book_append_sheet(wb, wsTrainings, 'Training Details');
            
//             XLSX.writeFile(wb, `training_calendar_${format(calendarDate, 'yyyy_MM')}.xlsx`);
//             toast.success('Excel exported successfully with summary!');
//         } catch (error) {
//             console.error("Excel export failed:", error);
//             toast.error('Failed to export Excel');
//         }
//     };

//     const handleShare = () => {
//         setShareUrl(window.location.href);
//         setShareDialogOpen(true);
//     };

//     const copyToClipboard = () => {
//         navigator.clipboard.writeText(shareUrl);
//         setSnackbarMessage('Link copied to clipboard!');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//     };

//     const shareViaEmail = () => {
//         const subject = `Training Calendar - ${format(calendarDate, 'MMMM yyyy')}`;
//         const stats = getMonthlyStats();
//         const body = `Training Calendar Summary:\n\nMonth: ${format(calendarDate, 'MMMM yyyy')}\nTotal Trainings: ${filteredTrainings.length}\nDriver Trainings: ${stats.driverTrainings}\nTechnical Trainings: ${stats.technicalTrainings}\nSafety Trainings: ${stats.safetyTrainings}\nIT Trainings: ${stats.itTrainings}\n\nView full calendar at: ${shareUrl}`;
//         window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
//     };

//     const shareViaWhatsApp = () => {
//         const stats = getMonthlyStats();
//         const text = `Training Calendar - ${format(calendarDate, 'MMMM yyyy')}\nTotal Trainings: ${filteredTrainings.length}\nDriver: ${stats.driverTrainings}, Technical: ${stats.technicalTrainings}, Safety: ${stats.safetyTrainings}, IT: ${stats.itTrainings}\nView here: ${shareUrl}`;
//         window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
//     };

//     const handleDownloadPNG = async () => {
//         if (!calendarRef.current) return;
//         try {
//             toast.info("Preparing PNG download...");
//             const clone = calendarRef.current.cloneNode(true);
//             const style = clone.ownerDocument.createElement('style');
//             style.textContent = `
//                 .react-calendar { width: 100%; max-width: 1200px; min-width: 800px; background: white; border: 1px solid #747171; border-radius: 8px; }
//                 .react-calendar__navigation button { min-width: 44px; font-size: 14px; background: white; color: black; border: none; }
//                 .react-calendar__month-view__weekdays { text-align: center; font-weight: bold; font-size: 0.75em; padding: 8px 0; background: #f5f5f5; }
//                 .react-calendar__month-view__days__day { padding: 8px 4px; min-height: 280px; border: 1px solid #838282; vertical-align: top; background: white; }
//                 .react-calendar__tile { min-height: 280px; text-align: left; vertical-align: top; padding: 8px 4px; background: white; }
//                 .react-calendar__tile abbr { font-weight: 600; font-size: 14px; padding: 2px 6px; border-radius: 50%; display: inline-block; color: black; }
//                 .weekend abbr { color: #050505 !important; }
//                 .training-card { background: white; border: 1px solid #7c7a7a; border-radius: 4px; padding: 8px; margin-bottom: 8px; font-size: 10px; color: #000000; }
//                 .training-name { font-weight: bold; font-size: 11px; margin-bottom: 4px; color: #000000; }
//                 .training-detail { font-size: 9px; margin-bottom: 3px; color: #000000; }
//                 .training-date-range { font-size: 9px; color: #1976d2; font-weight: 600; margin-bottom: 3px; }
//                 .training-type { display: inline-block; background: #f0f0f0; color: #333; padding: 2px 8px; border-radius: 12px; font-size: 8px; font-weight: bold; margin-top: 5px; }
//                 .training-card-text { color: #000000 !important; }
//                 .training-mode-badge { font-size: 8px; color: #666; margin-top: 2px; }
//                 .training-plan-badge { font-size: 8px; color: #666; }
//             `;
//             clone.prepend(style);
//             const tiles = clone.querySelectorAll('.react-calendar__tile');
//             tiles.forEach(tile => {
//                 const abbr = tile.querySelector('abbr');
//                 if (abbr) {
//                     const dateText = abbr.textContent;
//                     const dateNum = parseInt(dateText);
//                     if (!isNaN(dateNum)) {
//                         const currentMonth = calendarDate.getMonth();
//                         const currentYear = calendarDate.getFullYear();
//                         const tileDate = new Date(currentYear, currentMonth, dateNum);
//                         if (isWeekend(tileDate)) tile.classList.add('weekend');
//                     }
//                 }
//             });
//             const trainingContainers = clone.querySelectorAll('.react-calendar__tile');
//             trainingContainers.forEach(container => {
//                 const dateAbbr = container.querySelector('abbr');
//                 if (dateAbbr) {
//                     const dateText = dateAbbr.textContent;
//                     const dateNum = parseInt(dateText);
//                     if (!isNaN(dateNum)) {
//                         const currentMonth = calendarDate.getMonth();
//                         const currentYear = calendarDate.getFullYear();
//                         const containerDate = new Date(currentYear, currentMonth, dateNum);
//                         const trainingsMap = new Map();
//                         filteredTrainings.forEach(training => {
//                             if (isTrainingOnDate(training, containerDate)) {
//                                 if (!trainingsMap.has(training.id)) trainingsMap.set(training.id, training);
//                             }
//                         });
//                         const trainingsOnDate = Array.from(trainingsMap.values());
//                         const existingContent = container.querySelector('.training-items-container');
//                         if (existingContent) existingContent.remove();
//                         if (trainingsOnDate.length > 0) {
//                             const contentDiv = clone.ownerDocument.createElement('div');
//                             contentDiv.className = 'training-items-container';
//                             contentDiv.style.marginTop = '8px';
//                             trainingsOnDate.forEach((training, index) => {
//                                 let userName = training.trainerDisplayName || training.trainerName;
//                                 if (!userName || userName === 'Not Assigned') {
//                                     if (training.trainerId) {
//                                         const userIdNum = parseInt(training.trainerId);
//                                         if (trainerMap.has(userIdNum)) {
//                                             userName = trainerMap.get(userIdNum);
//                                         } else {
//                                             userName = 'Not Assigned';
//                                         }
//                                     } else {
//                                         userName = 'Not Assigned';
//                                     }
//                                 }
//                                 const originalTypeValue = training.originalType || extractOriginalType(training.type);
//                                 const timeInfo = getTrainingTimeInfo(training);
//                                 const dateRange = training.dateRange || getDateRangeString(training.trainingStartDate, training.trainingEndDate);
//                                 const cardDiv = clone.ownerDocument.createElement('div');
//                                 cardDiv.className = 'training-card';
//                                 cardDiv.style.color = '#000000';
//                                 cardDiv.innerHTML = `
//                                     ${index > 0 ? '<hr style="border-top: 2px dashed #ccc; margin: 4px 0 8px 0;" />' : ''}
//                                     <div class="training-name" style="color: #000000;">${escapeHtml(training.name || 'Unnamed Training')}</div>
//                                     ${dateRange ? `<div class="training-date-range">📅 ${escapeHtml(dateRange)}</div>` : ''}
//                                     <div class="training-detail" style="color: #000000;">📍 ${escapeHtml(training.depot || 'N/A')}</div>
//                                     <div class="training-detail" style="color: #000000;">📍 ${escapeHtml(training.state || 'N/A')}</div>
//                                     <div class="training-detail" style="color: #000000;">👨‍🏫 ${escapeHtml(userName)}</div>
//                                     ${timeInfo.timeDisplay && timeInfo.timeDisplay !== 'Time not specified' ? `<div class="training-detail" style="color: #000000;">⏰ ${escapeHtml(timeInfo.timeDisplay)} ${timeInfo.duration > 0 ? `(${timeInfo.duration}hr)` : ''}</div>` : ''}
//                                     ${training.trainingMode ? `<div class="training-mode-badge">📋 Mode: ${escapeHtml(training.trainingMode)}</div>` : `<div class="training-mode-badge">📋 Mode: N/A</div>`}
//                                     ${training.batchPlan ? `<div class="training-plan-badge">📊 Plan: ${escapeHtml(training.batchPlan)}</div>` : `<div class="training-plan-badge">📊 Plan: N/A</div>`}
//                                     <div class="training-type">${escapeHtml(originalTypeValue)}</div>
//                                 `;
//                                 contentDiv.appendChild(cardDiv);
//                             });
//                             container.appendChild(contentDiv);
//                         }
//                     }
//                 }
//             });
//             const container = clone.ownerDocument.createElement('div');
//             container.style.padding = '20px';
//             container.style.backgroundColor = 'white';
//             container.style.width = '100%';
//             container.style.maxWidth = '1200px';
//             container.style.margin = '0 auto';
//             const header = clone.ownerDocument.createElement('div');
//             header.innerHTML = `
//                 <h1 style="text-align: center; margin-bottom: 15px;">Training Calendar</h1>
//                 <div style="display: flex; justify-content: space-between; margin-bottom: 15px; padding: 10px; background: #f5f5f5; border-radius: 5px; flex-wrap: wrap; gap: 10px;">
//                     <div><strong>Generated:</strong> ${new Date().toLocaleString()}</div>
//                     <div><strong>Month:</strong> ${format(calendarDate, 'MMMM yyyy')}</div>
//                     <div><strong>Total Trainings:</strong> ${filteredTrainings.length}</div>
//                 </div>
//             `;
//             container.appendChild(header);
//             container.appendChild(clone);
//             document.body.appendChild(container);
//             const canvas = await html2canvas(container, { backgroundColor: "#ffffff", scale: 2, logging: false, useCORS: true });
//             document.body.removeChild(container);
//             const link = document.createElement("a");
//             link.download = `training_calendar_${format(calendarDate, 'yyyy_MM')}.png`;
//             link.href = canvas.toDataURL("image/png");
//             link.click();
//             toast.success('PNG downloaded successfully!');
//         } catch (err) {
//             console.error("Download failed:", err);
//             toast.error('Failed to download PNG');
//         }
//     };

//     const escapeHtml = (text) => {
//         if (!text) return '';
//         return String(text).replace(/[&<>]/g, function(m) {
//             if (m === '&') return '&amp;';
//             if (m === '<') return '&lt;';
//             if (m === '>') return '&gt;';
//             return m;
//         });
//     };

//     // Cleanup on unmount
//     useEffect(() => {
//         return () => {
//             if (abortControllerRef.current) {
//                 abortControllerRef.current.abort();
//             }
//         };
//     }, []);

//     if (isDataLoading) {
//         return (
//             <Container sx={{ mt: 4, mb: 4 }}>
//                 <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
//                     <CircularProgress size={60} />
//                     <Typography variant="h6" sx={{ mt: 2 }}>Loading Training Calendar...</Typography>
//                 </Paper>
//             </Container>
//         );
//     }

//     return (
//         <Container ref={mainContainerRef} sx={{ mt: 4, mb: 4, maxWidth: '1400px !important' }}>
//             <Paper elevation={3} sx={{ p: 4 }}>
//                 <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
//                     <Box>
//                         <Typography variant="h4" component="h1" gutterBottom>
//                             Training Calendar
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                             Role: <strong>{type || 'Guest'}</strong>
//                             {userInfo.userName && <> | Name: <strong>{userInfo.userName}</strong></>}
//                             {userInfo.assignedDepot && <> | Assigned Depot: <strong>{userInfo.assignedDepot}</strong></>}
//                             {filteredTrainings.length > 0 && <> | Total Trainings: <strong>{filteredTrainings.length}</strong></>}
//                             {isMonthLoading && <> | <CircularProgress size={20} /></>}
//                         </Typography>
//                     </Box>
//                     <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
//                         <Tooltip title="Toggle Time Format">
//                             <Button variant="outlined" onClick={toggleTimeFormat} startIcon={<TwentyFourMpIcon />} size="small">
//                                 {use24HourFormat ? "24h" : "12h"}
//                             </Button>
//                         </Tooltip>
//                         <Tooltip title="Print Calendar">
//                             <Button variant="outlined" onClick={handlePrint} startIcon={<PrintIcon />} size="small">
//                                 Print
//                             </Button>
//                         </Tooltip>
//                         <Tooltip title="Share Calendar">
//                             <Button variant="outlined" onClick={handleShare} startIcon={<ShareIcon />} size="small">
//                                 Share
//                             </Button>
//                         </Tooltip>
//                         <Tooltip title="Copy to Email Body">
//                             <Button variant="contained" onClick={handleCopyToEmail} startIcon={<EmailCopyIcon />} size="small" color="info">
//                                 Copy to Email
//                             </Button>
//                         </Tooltip>
//                         <Tooltip title="Export as PDF">
//                             <Button variant="outlined" onClick={handleExportPDF} startIcon={<PictureAsPdfIcon />} size="small" color="error">
//                                 PDF
//                             </Button>
//                         </Tooltip>
//                         <Tooltip title="Export as Excel">
//                             <Button variant="outlined" onClick={handleExportExcel} startIcon={<TableChartIcon />} size="small" color="success">
//                                 Excel
//                             </Button>
//                         </Tooltip>
//                         <Tooltip title="Download as PNG">
//                             <Button variant="outlined" onClick={handleDownloadPNG} startIcon={<DownloadIcon />} size="small" color="primary">
//                                 PNG
//                             </Button>
//                         </Tooltip>
//                         {userPermissions.canCreateTraining && (
//                             <Button variant="contained" color="primary" onClick={() => setIsCreateModalOpen(true)} size="small">
//                                 Create Training
//                             </Button>
//                         )}
//                     </Stack>
//                 </Stack>

//                 <Box sx={{ mb: 3 }}>
//                     <Typography variant="h6" gutterBottom>Filter by Training Type</Typography>
//                     <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
//                         <Chip label="All Trainings" clickable color={!selectedTrainingType ? "primary" : "default"} onClick={() => setSelectedTrainingType(null)} />
//                         {trainingTypes.map((type) => (
//                             <Chip
//                                 key={type.id}
//                                 label={type.name}
//                                 clickable
//                                 sx={{ backgroundColor: type.color, color: 'white', '&:hover': { opacity: 0.8 } }}
//                                 onClick={() => setSelectedTrainingType(type)}
//                             />
//                         ))}
//                     </Stack>
//                 </Box>

//                 <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                     <Typography variant="subtitle2" gutterBottom>Training Types Legend:</Typography>
//                     <Stack direction="row" spacing={2} flexWrap="wrap">
//                         {trainingTypes.map((type) => (
//                             <Box key={type.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 <Box sx={{ width: 16, height: 16, backgroundColor: type.color, borderRadius: 1 }} />
//                                 <Typography variant="caption">{type.name}</Typography>
//                             </Box>
//                         ))}
//                     </Stack>
//                 </Box>

//                 {(type === "Tata Project Manager" || type === "Tata Depot Manager") && (
//                     <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                         <Typography variant="h6" gutterBottom>Depot Filter</Typography>
//                         <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" gap={2}>
//                             <FormControl sx={{ minWidth: 250 }}>
//                                 <InputLabel>Select Depot</InputLabel>
//                                 <Select value={selectedDepot || ''} label="Select Depot" onChange={(e) => setSelectedDepot(e.target.value)}>
//                                     <MenuItem value="">All Depots</MenuItem>
//                                     {[...new Set([...availableDepots, ...allDepotOptions])].sort().map((depot) => (
//                                         <MenuItem key={depot} value={depot}>{depot}</MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//                             <Button variant="outlined" onClick={() => setSelectedDepot(null)}>Reset</Button>
//                         </Stack>
//                     </Box>
//                 )}

//                 <Alert severity="info" sx={{ mb: 2 }}>
//                     <strong>📅 Calendar Information:</strong> Displays a total of {filteredTrainings.length} training batches for {format(calendarDate, 'MMMM yyyy')}.
//                     <br />
//                     <strong>📧 Copy to Email:</strong> Click "Copy to Email" to copy the entire calendar view and paste directly into your email body. Trainer names are properly displayed.
//                     <br />
//                     <strong>📌 Separator Lines:</strong> Each training is separated by a dashed line for easy identification.
//                     <br />
//                     <strong>⚫ Training Names:</strong> All training names and details are displayed in black text for better readability.
//                     <br />
//                     <strong>📋 Training Mode & Batch Plan:</strong> Each training card now displays the training mode and batch plan number. If not available, shows "N/A".
//                     {isMonthLoading && <><br /><strong>🔄 Loading:</strong> Fetching trainings for this month...</>}
//                 </Alert>

//                 <Box sx={{ display: 'flex', justifyContent: 'center', overflowX: 'auto' }}>
//                     <div ref={calendarRef}>
//                         <style>
//                             {`
//                                 .react-calendar { width: 100%; max-width: 1200px; min-width: 800px; background: white; border: none; border-radius: 8px; }
//                                 .react-calendar__navigation button { min-width: 44px; font-size: 16px; margin-top: 8px; }
//                                 .react-calendar__month-view__weekdays { text-align: center; font-weight: bold; font-size: 0.75em; padding: 8px 0; }
//                                 .react-calendar__month-view__days__day { padding: 12px 6px; min-height: 350px; border: 1px solid #e0e0e0; vertical-align: top; background: white; }
//                                 .react-calendar__tile { min-height: 350px; text-align: left; vertical-align: top; padding: 12px 8px; background: white; display: flex; flex-direction: column; }
//                                 .react-calendar__tile--now { background: #f0f0f0; }
//                                 .react-calendar__tile abbr { font-weight: 600; font-size: 14px; padding: 4px 8px; border-radius: 50%; display: inline-block; color: black; }
//                                 .react-calendar__month-view__days__day--neighboringMonth { visibility: hidden; pointer-events: none; }
//                                 .react-calendar__tile.weekend abbr { color: #1a1919 !important; }
//                                 .react-calendar__tile .training-card { color: #000000 !important; }
//                                 .react-calendar__tile .training-name { color: #000000 !important; }
//                                 .react-calendar__tile .training-detail { color: #000000 !important; }
//                             `}
//                         </style>
//                         <Calendar
//                             onChange={setCalendarDate}
//                             value={calendarDate}
//                             onClickDay={handleDateClick}
//                             tileContent={tileContent}
//                             showNeighboringMonth={false}
//                             prev2Label={null}
//                             next2Label={null}
//                             formatMonthYear={(locale, date) => format(date, 'MMMM yyyy')}
//                             onActiveStartDateChange={handleActiveStartDateChange}
//                             tileClassName={({ date, view }) => {
//                                 if (view === 'month' && isWeekend(date)) return 'weekend';
//                                 return null;
//                             }}
//                         />
//                     </div>
//                 </Box>

//                 <TrainingDetailsModal
//                     isOpen={isDetailsModalOpen}
//                     onClose={() => setIsDetailsModalOpen(false)}
//                     trainings={selectedDateTrainings}
//                     onDeleteTraining={userPermissions.canDeleteTraining ? deleteTraining : null}
//                     onGenerateBatch={handleGenerateBatch}
//                     type={type}
//                     userInfo={userInfo}
//                 />

//                 <CreateTrainingModal
//                     isOpen={isCreateModalOpen}
//                     onClose={() => setIsCreateModalOpen(false)}
//                     onCreateTraining={createTraining}
//                     allBatch={allBatch}
//                     allTrainers={allUsers}
//                     allCourseNames={allCourseNames}
//                     loader={loader}
//                 />

//                 <Dialog open={shareDialogOpen} onClose={() => setShareDialogOpen(false)} maxWidth="sm" fullWidth>
//                     <DialogTitle>
//                         <Stack direction="row" justifyContent="space-between" alignItems="center">
//                             <Typography variant="h6">Share Calendar</Typography>
//                             <IconButton onClick={() => setShareDialogOpen(false)}><CloseIcon /></IconButton>
//                         </Stack>
//                     </DialogTitle>
//                     <DialogContent>
//                         <List>
//                             <ListItem button onClick={copyToClipboard}>
//                                 <ListItemIcon><ContentCopyIcon /></ListItemIcon>
//                                 <ListItemText primary="Copy Link" secondary="Copy calendar link to clipboard" />
//                             </ListItem>
//                             <Divider />
//                             <ListItem button onClick={shareViaEmail}>
//                                 <ListItemIcon><EmailIcon /></ListItemIcon>
//                                 <ListItemText primary="Email" secondary="Share via Email" />
//                             </ListItem>
//                             <Divider />
//                             <ListItem button onClick={shareViaWhatsApp}>
//                                 <ListItemIcon><WhatsAppIcon /></ListItemIcon>
//                                 <ListItemText primary="WhatsApp" secondary="Share via WhatsApp" />
//                             </ListItem>
//                         </List>
//                     </DialogContent>
//                     <DialogActions>
//                         <Button onClick={() => setShareDialogOpen(false)}>Close</Button>
//                     </DialogActions>
//                 </Dialog>

//                 <Dialog open={copyEmailDialogOpen} onClose={() => setCopyEmailDialogOpen(false)} maxWidth="md" fullWidth>
//                     <DialogTitle>
//                         <Stack direction="row" justifyContent="space-between" alignItems="center">
//                             <Typography variant="h6">Copy Calendar to Email</Typography>
//                             <IconButton onClick={() => setCopyEmailDialogOpen(false)}><CloseIcon /></IconButton>
//                         </Stack>
//                     </DialogTitle>
//                     <DialogContent>
//                         <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                             The calendar has been generated with all trainer information. Choose an option below:
//                         </Typography>
//                         <List>
//                             <ListItem button onClick={copyToClipboardEmail}>
//                                 <ListItemIcon><ContentCopyIcon sx={{ color: '#4caf50' }} /></ListItemIcon>
//                                 <ListItemText 
//                                     primary="Copy to Clipboard" 
//                                     secondary="Copy formatted content to paste directly into Gmail, Outlook, or any email client (Ctrl+V)" 
//                                 />
//                             </ListItem>
//                             <Divider />
//                             <ListItem button onClick={openEmailClient}>
//                                 <ListItemIcon><EmailIcon sx={{ color: '#2196f3' }} /></ListItemIcon>
//                                 <ListItemText 
//                                     primary="Open Email Client" 
//                                     secondary="Open your default email client with the calendar content" 
//                                 />
//                             </ListItem>
//                         </List>
//                         <Alert severity="info" sx={{ mt: 2 }}>
//                             <strong>💡 Features:</strong>
//                             <ul style={{ marginTop: 8, marginBottom: 0 }}>
//                                 <li><strong>Separator Lines:</strong> Dashed lines between each training for easy identification</li>
//                                 <li><strong>Fixed Size Boxes:</strong> Each training box has the same size</li>
//                                 <li><strong>Sticky Date Headers:</strong> Date and day always visible</li>
//                                 <li><strong>Training Count:</strong> Shows number of trainings per date</li>
//                                 <li><strong>📅 Date Range:</strong> Shows date range in format (start-end month)</li>
//                                 <li><strong>⚫ Black Text:</strong> All training names and details are displayed in black text for better readability</li>
//                                 <li><strong>📋 Training Mode & Batch Plan:</strong> Shows training mode and batch plan number. Shows "N/A" if not available.</li>
//                             </ul>
//                         </Alert>
//                     </DialogContent>
//                     <DialogActions>
//                         <Button onClick={() => setCopyEmailDialogOpen(false)}>Close</Button>
//                     </DialogActions>
//                 </Dialog>

//                 <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
//                     <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
//                         {snackbarMessage}
//                     </Alert>
//                 </Snackbar>
//             </Paper>
//         </Container>
//     );
// };

// export default TCalendar;









import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    Container, Typography, Button, Box, Stack, Paper, Snackbar, Alert, Chip,
    FormControl, InputLabel, Select, MenuItem, CircularProgress, Tooltip, IconButton,
    Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText,
    ListItemIcon, Divider
} from '@mui/material';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { format, parseISO, startOfDay, isBefore, isToday, getMonth, getYear } from 'date-fns';
import '../css/TrainingCalendarCustom.css';
import './TrainingCalendarCustom.css';
import CreateTrainingModal from './CreateTrainingModal';
import TrainingDetailsModal from './TrainingDetailModal';
import { createTrainingEntry, deleteTrainingEntry, fetchTrainingsByMonth, updateTrainingStatus } from 'helpers/training_helper';
import { toast } from 'react-toastify';
import { fetchAllBatch } from 'helpers/batch_helper';
import { fetchAllTrainers, getSingleUser, fetchAllUsers } from 'helpers/user_helper';
import html2canvas from 'html2canvas';
import { fetchCourseNames } from 'helpers/course_helper';
import { useNavigate } from 'react-router-dom';
import TwentyFourMpIcon from '@mui/icons-material/TwentyFourMp';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmailCopyIcon from '@mui/icons-material/MailOutline';
import html2pdf from 'html2pdf.js';
import * as XLSX from 'xlsx';

const TCalendar = ({ loader, setLoader }) => {
    const [trainings, setTrainings] = useState([]);
    const [selectedDateTrainings, setSelectedDateTrainings] = useState([]);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [calendarDate, setCalendarDate] = useState(new Date());
    const [selectedTrainingType, setSelectedTrainingType] = useState(null);
    const [filteredTrainings, setFilteredTrainings] = useState([]);
    const [selectedDepot, setSelectedDepot] = useState(null);
    const [availableDepots, setAvailableDepots] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isMonthLoading, setIsMonthLoading] = useState(false);
    const [use24HourFormat, setUse24HourFormat] = useState(true);
    const [shareDialogOpen, setShareDialogOpen] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const [copyEmailDialogOpen, setCopyEmailDialogOpen] = useState(false);
    const [emailBody, setEmailBody] = useState('');
    const [loadedMonths, setLoadedMonths] = useState(new Map());
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [allBatch, setAllBatch] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [trainerMap, setTrainerMap] = useState(new Map());
    const [allCourseNames, setAllCourseNames] = useState([]);
    const [type, setType] = useState(null);
    const [userPermissions, setUserPermissions] = useState({
        canCreateTraining: false, canDeleteTraining: false, canGenerateBatch: false
    });
    const [userInfo, setUserInfo] = useState({
        depot: null, trainerId: null, userName: null, userId: null, assignedDepot: null, userType: null
    });

    const calendarRef = useRef(null);
    const mainContainerRef = useRef(null);
    const navigate = useNavigate();
    const abortControllerRef = useRef(null);

    const trainingTypes = [
        { id: 1, name: "Safety", color: "#f44336", bgColor: "#ffebee" },
        { id: 2, name: "IT", color: "#2196f3", bgColor: "#e3f2fd" },
        { id: 3, name: "Technical", color: "#4caf50", bgColor: "#e8f5e9" },
        { id: 4, name: "Driver", color: "#ff9800", bgColor: "#fff3e0" }
    ];

    const allDepotOptions = [
        "BBM", "Backbay", "Bawana", "Bhagwati Nagar", "Deepanjali Nagar", "Dichaon Kalan",
        "Dwarka-8", "GTK", "Hari Nagar-2", "Hasanpur", "Hennur", "Indraprastha", "Jayanagar",
        "Jigani", "K R Puram", "Kalkaji", "Kalinga Nagar", "Kannalli", "Malwani", "Mayapuri",
        "Mera Mandali", "Mundela Kalan", "Nand Nagri", "Narela", "Naraina", "Naranpura",
        "Nehru Place", "Okhla", "Online", "Pantnagar", "Pantha Chowk", "Peenya", "Rohini-1",
        "Rohini-2", "Sarojini Nagar", "Shanti Nagar", "Shivaji Nagar", "Subhash Place",
        "Sukhdev Vihar", "Tekhand", "Tss", "Wazirpur", "Worli", "Traffic Management Centre (TMC)", "Vaddarahalli"
    ];

    const getMonthKey = (date) => `${getYear(date)}-${String(getMonth(date) + 1).padStart(2, '0')}`;

    const getDateRangeString = (startDate, endDate) => {
        if (!startDate || !endDate) return '';
        try {
            const start = new Date(startDate);
            const end = new Date(endDate);
            const startDay = format(start, 'd');
            const endDay = format(end, 'd');
            const startMonth = format(start, 'MMM');
            const endMonth = format(end, 'MMM');
            if (startMonth === endMonth) return `${startDay}-${endDay} ${startMonth}`;
            return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
        } catch (error) { return ''; }
    };

    const isDateInPast = (dateString) => {
        if (!dateString) return false;
        const date = parseISO(dateString);
        const today = startOfDay(new Date());
        return isBefore(date, today) && !isToday(date);
    };

    const convertTo12HourFormat = (time24) => {
        if (!time24) return '';
        if (time24.includes('AM') || time24.includes('PM')) return time24;
        const match = time24.match(/(\d{1,2}):(\d{2})/);
        if (!match) return time24;
        let hour = parseInt(match[1]);
        const minute = match[2];
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12;
        return `${hour}:${minute} ${ampm}`;
    };

    const convertTo24HourFormat = (time12) => {
        if (!time12) return '';
        if (time12.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) return time12;
        const match = time12.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        if (!match) return time12;
        let hour = parseInt(match[1]);
        const minute = match[2];
        const ampm = match[3].toUpperCase();
        if (ampm === 'PM' && hour !== 12) hour += 12;
        if (ampm === 'AM' && hour === 12) hour = 0;
        return `${hour.toString().padStart(2, '0')}:${minute}`;
    };

    const formatTimeDisplay = (timeStr) => {
        if (!timeStr) return '';
        if (use24HourFormat) return convertTo24HourFormat(timeStr);
        return convertTo12HourFormat(timeStr);
    };

    const calculateDuration = (startTime, endTime) => {
        if (!startTime || !endTime) return 0;
        try {
            const parseTime = (timeStr) => {
                let hours = 0, minutes = 0;
                const isPM = timeStr.toLowerCase().includes('pm');
                const timeWithoutSuffix = timeStr.replace(/\s*[ap]m$/i, '').trim();
                const [hourStr, minuteStr] = timeWithoutSuffix.split(':');
                hours = parseInt(hourStr);
                minutes = parseInt(minuteStr) || 0;
                if (isPM && hours !== 12) hours += 12;
                if (!isPM && hours === 12) hours = 0;
                return { hours, minutes };
            };
            const start = parseTime(startTime);
            const end = parseTime(endTime);
            let totalMinutes = (end.hours * 60 + end.minutes) - (start.hours * 60 + start.minutes);
            if (totalMinutes < 0) totalMinutes += 24 * 60;
            return Math.round((totalMinutes / 60) * 10) / 10;
        } catch (error) { return 0; }
    };

    const extractTimeFromType = (typeString) => {
        if (!typeString) return null;
        const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/gi;
        const match = timePattern.exec(typeString);
        if (match && match.length >= 3) {
            return {
                startTime: match[1], endTime: match[2],
                fullTimeRange: `${formatTimeDisplay(match[1])} - ${formatTimeDisplay(match[2])}`
            };
        }
        return null;
    };

    const extractDaysFromType = (typeString) => {
        if (!typeString) return null;
        const daysPattern = /-\s*(\d+)\s*(?:Day|Days|day|days)/i;
        const match = daysPattern.exec(typeString);
        if (match && match.length >= 2) return parseInt(match[1]);
        return null;
    };

    const extractOriginalType = (typeString) => {
        if (!typeString) return typeString;
        const timePattern = /-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?\s*-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?$/i;
        let typeWithoutTime = typeString.replace(timePattern, '').trim();
        const daysPattern = /-\s*\d+\s*(?:Day|Days|day|days)\s*$/i;
        typeWithoutTime = typeWithoutTime.replace(daysPattern, '').trim();
        return typeWithoutTime.replace(/-\s*$/, '').trim();
    };

    const getTrainingTimeInfo = (training) => {
        let startTime = '', endTime = '', duration = 0, timeDisplay = '';
        if (training.startTime && training.endTime) {
            startTime = training.startTime;
            endTime = training.endTime;
            const formattedStart = formatTimeDisplay(startTime);
            const formattedEnd = formatTimeDisplay(endTime);
            timeDisplay = `${formattedStart} - ${formattedEnd}`;
            duration = calculateDuration(formattedStart, formattedEnd);
        } else if (training.type && typeof training.type === 'string') {
            const timeFromType = extractTimeFromType(training.type);
            if (timeFromType) {
                startTime = timeFromType.startTime;
                endTime = timeFromType.endTime;
                timeDisplay = timeFromType.fullTimeRange;
                duration = calculateDuration(formatTimeDisplay(startTime), formatTimeDisplay(endTime));
            }
        } else if (training.timeSlotLabel) {
            timeDisplay = training.timeSlotLabel;
            const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/;
            const match = timePattern.exec(timeDisplay);
            if (match) {
                startTime = match[1];
                endTime = match[2];
                const formattedStart = formatTimeDisplay(startTime);
                const formattedEnd = formatTimeDisplay(endTime);
                timeDisplay = `${formattedStart} - ${formattedEnd}`;
                duration = calculateDuration(formattedStart, formattedEnd);
            }
        }
        if (duration === 0 && training.duration) duration = training.duration;
        if (!timeDisplay) timeDisplay = 'Time not specified';
        return { startTime, endTime, timeDisplay, duration };
    };

    const getUserName = (userId, training = null) => {
        if (training && training.trainerName && training.trainerName !== 'null' && training.trainerName !== 'undefined' && training.trainerName !== 'Not Assigned') {
            return training.trainerName;
        }
        if (!userId) return 'Not Assigned';
        const userIdNum = parseInt(userId);
        if (trainerMap.has(userIdNum)) {
            const mappedName = trainerMap.get(userIdNum);
            if (mappedName && mappedName !== 'Not Assigned') return mappedName;
        }
        const user = allUsers.find(u => parseInt(u.id) === userIdNum);
        if (user) {
            const userName = user.name || user.username || user.fullName || user.displayName || user.email?.split('@')[0] || 'User';
            if (userName && userName !== 'User') {
                setTrainerMap(prev => new Map(prev).set(userIdNum, userName));
                return userName;
            }
        }
        if (training && training.trainerName && training.trainerName !== 'null') return training.trainerName;
        return 'Not Assigned';
    };

    const getStatusInfo = (status) => {
        if (!status) return { label: 'N/A', color: '#9e9e9e', bgColor: '#f5f5f5', icon: '⚪' };
        const statusLower = status.toLowerCase();
        if (statusLower.includes('active')) return { label: 'Active', color: '#4caf50', bgColor: '#e8f5e9', icon: '🟢' };
        if (statusLower.includes('cancel')) return { label: 'Cancelled', color: '#f44336', bgColor: '#ffebee', icon: '🔴' };
        if (statusLower.includes('postpon')) return { label: 'Postponed', color: '#ff9800', bgColor: '#fff3e0', icon: '🟡' };
        if (statusLower.includes('complet')) return { label: 'Completed', color: '#2196f3', bgColor: '#e3f2fd', icon: '🔵' };
        return { label: status, color: '#9c27b0', bgColor: '#f3e5f5', icon: '🟣' };
    };

    useEffect(() => {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        if (authUser) {
            const userType = authUser.userType || authUser.userTypeDto?.name;
            setType(userType);
            const userName = authUser.name || authUser.username || "User";
            const userId = authUser.id || null;
            
            const fetchUserDepot = async () => {
                if (userId && (userType === "Tata Depot Manager" || userType === "Tata Project Manager")) {
                    try {
                        const userData = await getSingleUser(userId);
                        if (userData?.success && userData?.result?.[0]) {
                            const userDetails = userData.result[0];
                            let userAssignedDepot = null;
                            if (userDetails.tataUserDetailsDto?.depot) {
                                userAssignedDepot = userDetails.tataUserDetailsDto.depot;
                                authUser.depot = userAssignedDepot;
                                localStorage.setItem("authUser", JSON.stringify(authUser));
                            }
                            setUserInfo({
                                depot: userAssignedDepot, assignedDepot: userAssignedDepot,
                                trainerId: userId, userName: userName, userId: userId, userType: userType
                            });
                            if (userAssignedDepot && userType === "Tata Depot Manager") setSelectedDepot(userAssignedDepot);
                        }
                    } catch (error) {
                        handleLocalStorageUser(authUser, userType, userName, userId);
                    }
                } else {
                    handleLocalStorageUser(authUser, userType, userName, userId);
                }
            };
            
            const handleLocalStorageUser = (authUser, userType, userName, userId) => {
                let userAssignedDepot = authUser.depot || authUser.tataUserDetailsDto?.depot || null;
                setUserInfo({
                    depot: userAssignedDepot, assignedDepot: userAssignedDepot,
                    trainerId: userId, userName: userName, userId: userId, userType: userType
                });
                if (userAssignedDepot && userType === "Tata Depot Manager") setSelectedDepot(userAssignedDepot);
            };
            
            fetchUserDepot();
            setUserPermissions({
                canCreateTraining: ["Tata Project Manager", "Admin", "Super Admin"].includes(userType),
                canDeleteTraining: ["Tata Project Manager", "Admin", "Super Admin"].includes(userType),
                canGenerateBatch: ["Tata Project Manager", "Admin", "Super Admin", "Trainer"].includes(userType)
            });
        }
    }, []);

    const filterTrainingsByRole = (trainingsData) => {
        if (!trainingsData || !type) return trainingsData;
        let filtered = [...trainingsData];
        if (type === "Tata Project Manager" && selectedDepot) {
            filtered = filtered.filter(training => training.depot?.trim().toLowerCase() === selectedDepot.trim().toLowerCase());
        } else if (type === "Tata Depot Manager" && selectedDepot) {
            filtered = filtered.filter(training => training.depot?.trim().toLowerCase() === selectedDepot.trim().toLowerCase());
        } else if (type === "Tata Depot Manager" && !selectedDepot) {
            filtered = [];
        } else if (type === "Tata Trainer" && userInfo.trainerId) {
            filtered = filtered.filter(training => parseInt(training.trainerId) === parseInt(userInfo.trainerId));
        }
        const uniqueFiltered = [];
        const seenIds = new Set();
        for (const training of filtered) {
            if (!seenIds.has(training.id)) {
                seenIds.add(training.id);
                uniqueFiltered.push(training);
            }
        }
        return uniqueFiltered;
    };

    const fetchTrainingsForMonth = useCallback(async (date, forceRefresh = false) => {
        const year = getYear(date);
        const month = getMonth(date) + 1;
        const monthKey = getMonthKey(date);
        
        if (!forceRefresh && loadedMonths.has(monthKey)) {
            const cachedTrainings = loadedMonths.get(monthKey);
            setTrainings(cachedTrainings);
            setFilteredTrainings(filterTrainingsByRole(cachedTrainings));
            return cachedTrainings;
        }
        
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        
        try {
            setIsMonthLoading(true);
            const data = await fetchTrainingsByMonth(year, month);
            
            if (data?.success && data?.result) {
                const uniqueTrainingsMap = new Map();
                data.result.forEach(training => {
                    if (!uniqueTrainingsMap.has(training.id)) uniqueTrainingsMap.set(training.id, training);
                });
                const uniqueTrainings = Array.from(uniqueTrainingsMap.values());
                
                const formattedData = uniqueTrainings.map(training => {
                    const startDate = new Date(training.trainingStartDate);
                    const endDate = new Date(training.trainingEndDate);
                    const timeInfo = getTrainingTimeInfo(training);
                    const originalType = extractOriginalType(training.type);
                    const daysFromType = extractDaysFromType(training.type);
                    let userName = 'Not Assigned';
                    if (training.trainerName && training.trainerName !== 'null' && training.trainerName !== 'undefined') {
                        userName = training.trainerName;
                    } else if (training.trainerId) {
                        userName = getUserName(training.trainerId, training);
                    }
                    return {
                        ...training,
                        trainingStartDate: startDate,
                        trainingEndDate: endDate,
                        startTime: timeInfo.startTime,
                        endTime: timeInfo.endTime,
                        duration: timeInfo.duration,
                        timeDisplay: timeInfo.timeDisplay,
                        originalType: originalType || training.type,
                        daysFromType: daysFromType,
                        trainerName: userName,
                        trainerDisplayName: userName,
                        isPastDate: isDateInPast(training.trainingStartDate),
                        isTechnicalTraining: training.type?.includes('Technical') || originalType?.includes('Technical'),
                        technicalAssessmentType: training.technicalAssessmentType || '',
                        allowPreviousDates: training.allowPreviousDates !== false,
                        batchSchedule: training.batchSchedule || [],
                        trainingDaysCount: training.trainingDaysCount || training.trainingDays || daysFromType,
                        use24HourFormat: training.use24HourFormat !== undefined ? training.use24HourFormat : true,
                        dateRange: getDateRangeString(training.trainingStartDate, training.trainingEndDate),
                        trainingMode: training.trainingMode || null,
                        batchPlan: training.batchPlan || null,
                        status: training.status || 'Active'
                    };
                });
                
                setLoadedMonths(prev => new Map(prev).set(monthKey, formattedData));
                const depots = [...new Set(formattedData.map(t => t.depot).filter(Boolean))];
                setAvailableDepots(depots.sort());
                setTrainings(formattedData);
                setFilteredTrainings(filterTrainingsByRole(formattedData));
                return formattedData;
            } else {
                setLoadedMonths(prev => new Map(prev).set(monthKey, []));
                setTrainings([]);
                setFilteredTrainings([]);
                return [];
            }
        } catch (error) {
            if (error.name === 'AbortError') return [];
            console.error("Error fetching trainings for month:", error);
            setSnackbarMessage('Failed to fetch trainings for this month.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return [];
        } finally {
            setIsMonthLoading(false);
            if (setLoader) setLoader(false);
        }
    }, [loadedMonths, filterTrainingsByRole, setLoader, getUserName]);

    useEffect(() => {
        const loadInitialData = async () => {
            setIsDataLoading(true);
            await getAllUsersData();
            await getAllBatchesData();
            await getAllCourseNamesData();
            const currentDate = new Date();
            setCalendarDate(currentDate);
            await fetchTrainingsForMonth(currentDate, true);
            setIsDataLoading(false);
        };
        loadInitialData();
    }, []);

    const handleActiveStartDateChange = useCallback(async ({ activeStartDate }) => {
        if (!activeStartDate) return;
        const newDate = activeStartDate;
        const currentMonth = getMonth(calendarDate);
        const newMonth = getMonth(newDate);
        if (newMonth !== currentMonth || getYear(newDate) !== getYear(calendarDate)) {
            setCalendarDate(newDate);
            await fetchTrainingsForMonth(newDate);
        }
    }, [calendarDate, fetchTrainingsForMonth]);

    useEffect(() => {
        if (selectedTrainingType || selectedDepot) {
            let filtered = [...trainings];
            if (selectedTrainingType) {
                filtered = filtered.filter(training => extractOriginalType(training.type) === selectedTrainingType.name);
            }
            setFilteredTrainings(filterTrainingsByRole(filtered));
        } else {
            setFilteredTrainings(filterTrainingsByRole(trainings));
        }
    }, [selectedTrainingType, selectedDepot, trainings, type, userInfo]);

    const getAllBatchesData = async () => {
        try {
            const result = await fetchAllBatch();
            if (result?.success) setAllBatch(result?.result || []);
        } catch (error) {
            console.error("Error fetching batches:", error);
            setAllBatch([]);
        }
    };

    const getAllCourseNamesData = async () => {
        try {
            const result = await fetchCourseNames();
            if (result?.success) setAllCourseNames(result?.result || []);
        } catch (error) {
            console.error("Error fetching course names:", error);
            setAllCourseNames([]);
        }
    };

    const getAllUsersData = async () => {
        try {
            const data = await fetchAllUsers();
            if (data?.success && data?.result) {
                setAllUsers(data.result);
                const map = new Map();
                data.result.forEach(user => {
                    const userId = parseInt(user.id);
                    const userName = user.name || user.username || user.fullName || user.displayName || user.email?.split('@')[0] || 'User';
                    if (userName && userName !== 'User') map.set(userId, userName);
                });
                setTrainerMap(map);
            } else {
                const trainerData = await fetchAllTrainers();
                if (trainerData?.success && trainerData?.result) {
                    setAllUsers(trainerData.result);
                    const map = new Map();
                    trainerData.result.forEach(user => {
                        const userId = parseInt(user.id);
                        const userName = user.name || user.username || user.fullName || 'Trainer';
                        if (userName && userName !== 'Trainer') map.set(userId, userName);
                    });
                    setTrainerMap(map);
                } else {
                    setAllUsers([]);
                    setTrainerMap(new Map());
                }
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            try {
                const trainerData = await fetchAllTrainers();
                if (trainerData?.success && trainerData?.result) {
                    setAllUsers(trainerData.result);
                    const map = new Map();
                    trainerData.result.forEach(user => {
                        const userId = parseInt(user.id);
                        const userName = user.name || user.username || user.fullName || 'Trainer';
                        map.set(userId, userName);
                    });
                    setTrainerMap(map);
                } else {
                    setAllUsers([]);
                    setTrainerMap(new Map());
                }
            } catch (innerError) {
                console.error("Error fetching trainers fallback:", innerError);
                setAllUsers([]);
                setTrainerMap(new Map());
            }
        }
    };

    const createTraining = async (trainingData) => {
        try {
            if (setLoader) setLoader(true);
            const formattedStartTime = formatTimeDisplay(trainingData.startTime);
            const formattedEndTime = formatTimeDisplay(trainingData.endTime);
            const calculatedDuration = calculateDuration(formattedStartTime, formattedEndTime);
            
            const apiData = {
                name: trainingData.name,
                originalName: trainingData.originalName || trainingData.name,
                depot: trainingData.depot,
                type: trainingData.type,
                originalType: trainingData.originalType || extractOriginalType(trainingData.type),
                technicalAssessmentType: trainingData.technicalAssessmentType,
                state: trainingData.state,
                trainingStartDate: trainingData.trainingStartDate,
                trainingEndDate: trainingData.trainingEndDate,
                trainerId: trainingData.trainerId,
                trainerName: trainingData.trainerName,
                trainerEmail: trainingData.trainerEmail,
                trainerPhone: trainingData.trainerPhone,
                trainerType: trainingData.trainerType,
                trainingDays: trainingData.trainingDays,
                startTime: trainingData.startTime,
                endTime: trainingData.endTime,
                startHour: trainingData.startHour,
                endHour: trainingData.endHour,
                timeSlotLabel: trainingData.timeSlotLabel,
                timeSlotShortLabel: trainingData.timeSlotShortLabel,
                actualTrainingDays: trainingData.actualTrainingDays || trainingData.trainingDays,
                isTechnicalTraining: trainingData.isTechnicalTraining || false,
                isManualDateSelection: trainingData.isManualDateSelection || false,
                allowPreviousDates: trainingData.allowPreviousDates || true,
                batchSchedule: trainingData.batchSchedule || [],
                trainingDaysCount: trainingData.trainingDaysCount || trainingData.trainingDays,
                timeDisplay: `${formattedStartTime} - ${formattedEndTime}`,
                duration: calculatedDuration,
                use24HourFormat: trainingData.use24HourFormat !== undefined ? trainingData.use24HourFormat : true,
                trainingMode: trainingData.trainingMode || null,
                batchPlan: trainingData.batchPlan || null,
                status: trainingData.status || 'Active',
                courseId: trainingData.courseId || null,
                courseTitle: trainingData.courseTitle || trainingData.name
            };
            
            const startDate = new Date(trainingData.trainingStartDate);
            const endDate = new Date(trainingData.trainingEndDate);
            const [startHour, startMinute] = trainingData.startTime.split(':').map(Number);
            startDate.setHours(startHour, startMinute || 0, 0, 0);
            apiData.trainingStartDate = startDate.toISOString();
            const [endHour, endMinute] = trainingData.endTime.split(':').map(Number);
            endDate.setHours(endHour, endMinute || 0, 0, 0);
            apiData.trainingEndDate = endDate.toISOString();
            
            const data = await createTrainingEntry(apiData);
            if (data.success) {
                await fetchTrainingsForMonth(calendarDate, true);
                setIsCreateModalOpen(false);
                setSnackbarMessage('Training created successfully!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            } else {
                toast.error(data?.message || 'Failed to create training');
            }
        } catch (error) {
            setSnackbarMessage(`Failed to create training: ${error.message}`);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            if (setLoader) setLoader(false);
        }
    };

    const deleteTraining = async (trainingId) => {
        if (!window.confirm("Are you sure you want to delete this training?")) return;
        try {
            if (setLoader) setLoader(true);
            const data = await deleteTrainingEntry(trainingId);
            if (!data.success) throw new Error(data?.message);
            await fetchTrainingsForMonth(calendarDate, true);
            setIsDetailsModalOpen(false);
            setSnackbarMessage('Training deleted successfully!');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
        } catch (error) {
            setSnackbarMessage(`Failed to delete training: ${error.message}`);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            if (setLoader) setLoader(false);
        }
    };

    const handleUpdateTraining = async (payload) => {
        try {
            if (setLoader) setLoader(true);
            const data = await updateTrainingStatus(payload.id, payload);
            if (data?.success) {
                await fetchTrainingsForMonth(calendarDate, true);
                setSnackbarMessage('Training updated successfully!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            } else {
                throw new Error(data?.message || 'Failed to update training');
            }
        } catch (error) {
            console.error('Error updating training:', error);
            setSnackbarMessage(`Failed to update training: ${error.message}`);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            throw error;
        } finally {
            if (setLoader) setLoader(false);
        }
    };

    const handleGenerateBatch = (training) => {
        const timeInfo = getTrainingTimeInfo(training);
        const batchData = {
            batchName: `${training.name}_${format(new Date(training.trainingStartDate), 'yyyyMMdd')}`,
            trainingId: training.id,
            trainingName: training.name,
            trainingType: training.originalType || extractOriginalType(training.type),
            depot: training.depot,
            state: training.state,
            startDate: training.trainingStartDate,
            endDate: training.trainingEndDate,
            trainerId: training.trainerId,
            trainingDays: training.trainingDays,
            startTime: timeInfo.startTime,
            endTime: timeInfo.endTime,
            timeSlotLabel: timeInfo.timeDisplay,
            batchSchedule: training.batchSchedule || [],
            use24HourFormat: use24HourFormat,
            trainingMode: training.trainingMode || null,
            batchPlan: training.batchPlan || null
        };
        navigate('/all-batches', { state: { trainingData: batchData } });
    };

    useEffect(() => {
        if (allUsers.length > 0 && trainings.length > 0) {
            const updatedTrainings = trainings.map(training => {
                let userName = training.trainerName;
                if ((!userName || userName === 'Not Assigned') && training.trainerId) {
                    userName = getUserName(training.trainerId, training);
                }
                return { ...training, trainerName: userName, trainerDisplayName: userName };
            });
            setTrainings(updatedTrainings);
            setFilteredTrainings(prev => prev.map(t => {
                let userName = t.trainerName;
                if ((!userName || userName === 'Not Assigned') && t.trainerId) {
                    userName = getUserName(t.trainerId, t);
                }
                return { ...t, trainerName: userName, trainerDisplayName: userName };
            }));
        }
    }, [allUsers]);

    const isTrainingOnDate = (training, date) => {
        if (!training.trainingStartDate || !training.trainingEndDate) return false;
        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);
        const startDate = new Date(training.trainingStartDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(training.trainingEndDate);
        endDate.setHours(0, 0, 0, 0);
        return checkDate >= startDate && checkDate <= endDate;
    };

    const handleDateClick = (date) => {
        const trainingsOnDate = filteredTrainings.filter(training => isTrainingOnDate(training, date));
        setSelectedDateTrainings(trainingsOnDate);
        setIsDetailsModalOpen(true);
    };

    const isWeekend = (date) => {
        const day = date.getDay();
        return day === 0 || day === 6;
    };

    const getCurrentMonthTrainings = useCallback(() => {
        const currentMonth = getMonth(calendarDate);
        const currentYear = getYear(calendarDate);
        return filteredTrainings.filter(training => {
            const startMonth = getMonth(new Date(training.trainingStartDate));
            const startYear = getYear(new Date(training.trainingStartDate));
            return startMonth === currentMonth && startYear === currentYear;
        });
    }, [filteredTrainings, calendarDate]);

    const TrainingCard = ({ training, onClick, isForDownload = false }) => {
        let userName = training.trainerDisplayName || training.trainerName;
        if (!userName || userName === 'Not Assigned') {
            if (training.trainerId) userName = getUserName(training.trainerId, training);
            else userName = 'Not Assigned';
        }
        const originalTypeValue = training.originalType || extractOriginalType(training.type);
        const isPastDate = training.isPastDate || isDateInPast(training.trainingStartDate);
        const timeInfo = getTrainingTimeInfo(training);
        const trainingType = trainingTypes.find(t => t.name === originalTypeValue) || trainingTypes[0];
        const dateRange = training.dateRange || getDateRangeString(training.trainingStartDate, training.trainingEndDate);
        const statusInfo = getStatusInfo(training.status);
        
        return (
            <Box 
                key={`training-card-${training.id}`} 
                onClick={!isForDownload ? onClick : undefined} 
                sx={{
                    backgroundColor: trainingType.bgColor,
                    borderLeft: `4px solid ${trainingType.color}`,
                    border: `1px solid ${trainingType.color}40`,
                    borderRadius: "4px", padding: isForDownload ? "10px" : "8px",
                    marginBottom: "8px", fontSize: isForDownload ? "12px" : "0.7rem",
                    lineHeight: 1.5, position: 'relative', wordBreak: 'break-word',
                    color: '#000000',
                    ...(!isForDownload && { cursor: 'pointer', transition: 'all 0.2s ease',
                        '&:hover': { transform: 'scale(1.02)', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' } })
                }}
            >
                {isPastDate && !isForDownload && (
                    <Box sx={{ position: 'absolute', top: 2, right: 2, bgcolor: '#ff9800', color: 'white', fontSize: "0.5rem", px: 0.5, py: 0.2, borderRadius: "2px" }}>
                        PAST
                    </Box>
                )}
                {training.status && (
                    <Box sx={{ position: 'absolute', top: 2, left: 2, bgcolor: statusInfo.color, color: 'white', fontSize: "0.5rem", px: 0.5, py: 0.2, borderRadius: "2px", fontWeight: 'bold', zIndex: 2 }}>
                        {statusInfo.icon} {statusInfo.label}
                    </Box>
                )}
                <Typography fontWeight="bold" sx={{ fontSize: isForDownload ? "13px" : "0.75rem", mb: 0.5, wordBreak: 'break-word', pr: 3, pt: training.status ? 1.5 : 0, color: '#000000' }}>
                    {training.name || 'Unnamed Training'}
                </Typography>
                {dateRange && (
                    <Typography sx={{ fontSize: isForDownload ? "11px" : "0.6rem", mb: 0.3, color: '#1976d2', fontWeight: 600, wordBreak: 'break-word' }}>
                        📅 {dateRange}
                    </Typography>
                )}
                <Typography sx={{ fontSize: isForDownload ? "11px" : "0.65rem", mb: 0.3, color: '#000000' }}>
                    📍 {training.depot}
                </Typography>
                <Typography sx={{ fontSize: isForDownload ? "11px" : "0.65rem", mb: 0.3, color: '#000000' }}>
                    📍 {training.state}
                </Typography>
                <Typography sx={{ fontSize: isForDownload ? "11px" : "0.65rem", mb: 0.3, color: '#000000', fontWeight: 500 }}>
                    👨‍🏫 {userName}
                </Typography>
                {timeInfo.timeDisplay && timeInfo.timeDisplay !== 'Time not specified' && (
                    <Typography sx={{ fontSize: isForDownload ? "11px" : "0.65rem", mb: 0.3, color: '#000000' }}>
                        ⏰ {timeInfo.timeDisplay} {timeInfo.duration > 0 && `(${timeInfo.duration}hr)`}
                    </Typography>
                )}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                    {training.status && (
                        <Chip label={`${statusInfo.icon} ${statusInfo.label}`} size="small"
                            sx={{ fontSize: '0.55rem', height: 20, bgcolor: statusInfo.bgColor, color: statusInfo.color, fontWeight: 'bold', border: `1px solid ${statusInfo.color}` }} />
                    )}
                    <Chip label={`📋 ${training.trainingMode || 'N/A'}`} size="small" variant="outlined" color="info" sx={{ fontSize: '0.55rem', height: 20 }} />
                    <Chip label={`📊 Plan: ${training.batchPlan || 'N/A'}`} size="small" variant="outlined" color="secondary" sx={{ fontSize: '0.55rem', height: 20 }} />
                </Box>
                <Box sx={{ display: 'inline-block', backgroundColor: trainingType.color, color: 'white', padding: "4px 10px", borderRadius: "16px", fontSize: isForDownload ? "10px" : "0.6rem", fontWeight: "bold", marginTop: "6px" }}>
                    {originalTypeValue}
                </Box>
            </Box>
        );
    };

    const tileContent = ({ date, view }) => {
        if (view !== "month") return null;
        const currentMonth = calendarDate.getMonth();
        const currentYear = calendarDate.getFullYear();
        if (date.getMonth() !== currentMonth || date.getFullYear() !== currentYear) return null;
        
        const trainingsMap = new Map();
        filteredTrainings.forEach(training => {
            if (isTrainingOnDate(training, date)) {
                if (!trainingsMap.has(training.id)) trainingsMap.set(training.id, training);
            }
        });
        const trainingsOnDate = Array.from(trainingsMap.values());
        if (trainingsOnDate.length === 0) return null;
        const sortedTrainings = [...trainingsOnDate].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        
        return (
            <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {sortedTrainings.map((training) => (
                    <TrainingCard key={`${training.id}-${format(date, 'yyyy-MM-dd')}`} training={training} onClick={() => handleDateClick(date)} isForDownload={false} />
                ))}
            </Box>
        );
    };

    const toggleTimeFormat = () => {
        setUse24HourFormat(!use24HourFormat);
        setTimeout(() => fetchTrainingsForMonth(calendarDate, true), 100);
    };

    const getMonthlyStats = useCallback(() => {
        const currentMonthTrainings = getCurrentMonthTrainings();
        return {
            total: currentMonthTrainings.length,
            driverTrainings: currentMonthTrainings.filter(t => (t.originalType || extractOriginalType(t.type)) === 'Driver').length,
            technicalTrainings: currentMonthTrainings.filter(t => (t.originalType || extractOriginalType(t.type)) === 'Technical').length,
            safetyTrainings: currentMonthTrainings.filter(t => (t.originalType || extractOriginalType(t.type)) === 'Safety').length,
            itTrainings: currentMonthTrainings.filter(t => (t.originalType || extractOriginalType(t.type)) === 'IT').length
        };
    }, [getCurrentMonthTrainings]);

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function(m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    const generateEmailHTML = useCallback(() => {
        const stats = getMonthlyStats();
        const year = calendarDate.getFullYear();
        const month = calendarDate.getMonth();
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        const startDayOfWeek = firstDayOfMonth.getDay();
        const daysInMonth = lastDayOfMonth.getDate();
        const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const shortWeekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        
        let calendarHTML = '<table style="width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; font-size: 11px; table-layout: fixed;">';
        calendarHTML += '<thead><tr style="background: #f5f5f5;">';
        weekdays.forEach(day => {
            calendarHTML += `<th style="padding: 8px; border: 1px solid #ddd; text-align: center; font-size: 11px; background: #f5f5f5; width: 14.28%;">${day.slice(0, 3)}</th>`;
        });
        calendarHTML += '</tr></thead><tbody><tr>';
        
        for (let i = 0; i < startDayOfWeek; i++) {
            calendarHTML += `<td style="padding: 4px; border: 1px solid #ddd; background: #fafafa; width: 14.28%;">&nbsp;</td>`;
        }
        
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month, day);
            const isWeekendDay = date.getDay() === 0 || date.getDay() === 6;
            const trainingsOnDate = filteredTrainings.filter(training => isTrainingOnDate(training, date));
            const dayOfWeek = shortWeekdays[date.getDay()];
            
            calendarHTML += `
                <td style="padding: 4px; border: 1px solid #ddd; vertical-align: top; ${isWeekendDay ? 'background: #fff8e1;' : 'background: white;'} width: 14.28%;">
                    <div style="padding: 4px 0; border-bottom: 2px solid #1976d2; margin-bottom: 6px;">
                        <strong style="font-size: 13px; color: #1976d2;">${day} ${dayOfWeek}</strong>
                        ${trainingsOnDate.length > 0 ? `<span style="font-size: 10px; color: #666; margin-left: 6px;">(${trainingsOnDate.length})</span>` : ''}
                    </div>
                    ${trainingsOnDate.map((training) => {
                        let userName = training.trainerDisplayName || training.trainerName || 'Not Assigned';
                        const originalTypeValue = training.originalType || extractOriginalType(training.type);
                        const timeInfo = getTrainingTimeInfo(training);
                        const trainingType = trainingTypes.find(t => t.name === originalTypeValue) || trainingTypes[0];
                        const dateRange = training.dateRange || getDateRangeString(training.trainingStartDate, training.trainingEndDate);
                        const statusInfo = getStatusInfo(training.status);
                        
                        return `
                            <div style="background: ${trainingType.bgColor}; border: 2px solid ${trainingType.color}; border-radius: 4px; padding: 6px 8px; margin-bottom: 6px; color: #000000;">
                                ${training.status ? `<div style="font-size: 8px; color: ${statusInfo.color}; font-weight: bold;">${statusInfo.icon} ${statusInfo.label}</div>` : ''}
                                <strong style="font-size: 11px; color: #000000;">${escapeHtml(training.name || 'Unnamed')}</strong>
                                ${dateRange ? `<div style="font-size: 9px; color: #1976d2;">📅 ${escapeHtml(dateRange)}</div>` : ''}
                                <div style="font-size: 9px; color: #000000;">📍 ${escapeHtml(training.depot || 'N/A')}</div>
                                <div style="font-size: 9px; color: #000000;">👨‍🏫 ${escapeHtml(userName)}</div>
                                ${timeInfo.timeDisplay && timeInfo.timeDisplay !== 'Time not specified' ? `<div style="font-size: 9px; color: #000000;">⏰ ${escapeHtml(timeInfo.timeDisplay)}</div>` : ''}
                                <div style="font-size: 8px; color: #666;">📋 Mode: ${escapeHtml(training.trainingMode || 'N/A')}</div>
                                <div style="font-size: 8px; color: #666;">📊 Plan: ${escapeHtml(training.batchPlan || 'N/A')}</div>
                                <span style="background: ${trainingType.color}; color: white; padding: 1px 8px; border-radius: 10px; font-size: 8px; font-weight: bold;">${escapeHtml(originalTypeValue)}</span>
                            </div>
                        `;
                    }).join('')}
                </td>
            `;
            if ((startDayOfWeek + day) % 7 === 0 && day !== daysInMonth) calendarHTML += '</tr><tr>';
        }
        
        const totalCells = startDayOfWeek + daysInMonth;
        const remainingCells = (7 - (totalCells % 7)) % 7;
        for (let i = 0; i < remainingCells; i++) {
            calendarHTML += `<td style="padding: 4px; border: 1px solid #8a8484; background: #faf7f7; width: 14.28%;">&nbsp;</td>`;
        }
        calendarHTML += '</tr></tbody></table>';
        
        return `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Training Calendar</title>
        <style>
            body { font-family: Arial, sans-serif; padding: 10px; background: #f5f5f5; }
            .container { background: white; padding: 15px; border-radius: 6px; }
            h1 { color: #1976d2; text-align: center; }
        </style></head>
        <body><div class="container">
            <h1>📅 Training Calendar</h1>
            <div style="padding: 10px; background: #f5f5f5; border-radius: 6px; margin-bottom: 15px;">
                <strong>Month:</strong> ${format(calendarDate, 'MMMM yyyy')} | <strong>Total:</strong> ${filteredTrainings.length}
            </div>
            <div style="display: flex; gap: 12px; margin-bottom: 15px; padding: 12px; background: #e3f2fd; border-radius: 6px;">
                <div>📊 <strong>${stats.total}</strong> Total</div>
                <div>🚗 <strong>${stats.driverTrainings}</strong> Driver</div>
                <div>💻 <strong>${stats.technicalTrainings}</strong> Technical</div>
                <div>🛡️ <strong>${stats.safetyTrainings}</strong> Safety</div>
                <div>🔷 <strong>${stats.itTrainings}</strong> IT</div>
            </div>
            ${calendarHTML}
            <div style="margin-top: 20px; text-align: center; font-size: 10px; color: #666;">
                Generated on ${new Date().toLocaleString()}
            </div>
        </div></body></html>`;
    }, [calendarDate, filteredTrainings, getMonthlyStats, type, use24HourFormat, trainerMap, allUsers]);

    const handleCopyToEmail = () => {
        const emailHTML = generateEmailHTML();
        setEmailBody(emailHTML);
        setCopyEmailDialogOpen(true);
    };

    const stripHtml = (html) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    };

    const copyToClipboardEmail = async () => {
        try {
            const blob = new Blob([emailBody], { type: 'text/html' });
            if (navigator.clipboard && navigator.clipboard.write) {
                const clipboardItem = new ClipboardItem({
                    'text/html': blob,
                    'text/plain': new Blob([stripHtml(emailBody)], { type: 'text/plain' })
                });
                await navigator.clipboard.write([clipboardItem]);
            } else {
                await navigator.clipboard.writeText(stripHtml(emailBody));
            }
            setSnackbarMessage('Calendar copied to clipboard!');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            setCopyEmailDialogOpen(false);
        } catch (err) {
            navigator.clipboard.writeText(stripHtml(emailBody));
            setSnackbarMessage('Calendar copied as text.');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            setCopyEmailDialogOpen(false);
        }
    };

    const openEmailClient = () => {
        const subject = `Training Calendar - ${format(calendarDate, 'MMMM yyyy')}`;
        const body = stripHtml(emailBody);
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        setCopyEmailDialogOpen(false);
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(generateEmailHTML());
        printWindow.document.close();
        printWindow.print();
    };

    const handleExportPDF = async () => {
        try {
            toast.info("Generating PDF...");
            const element = document.createElement('div');
            element.innerHTML = generateEmailHTML();
            document.body.appendChild(element);
            const opt = {
                margin: [0.5, 0.5, 0.5, 0.5],
                filename: `training_calendar_${format(calendarDate, 'yyyy_MM')}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'a2', orientation: 'landscape' }
            };
            html2pdf().set(opt).from(element).save();
            document.body.removeChild(element);
            toast.success('PDF exported successfully!');
        } catch (error) {
            console.error("PDF export failed:", error);
            toast.error('Failed to export PDF');
        }
    };

    const handleExportExcel = () => {
        try {
            const stats = getMonthlyStats();
            const summaryData = [
                ['Training Calendar Summary - ' + format(calendarDate, 'MMMM yyyy')], [''],
                ['Total Trainings', stats.total], ['Driver Trainings', stats.driverTrainings],
                ['Technical Trainings', stats.technicalTrainings], ['Safety Trainings', stats.safetyTrainings],
                ['IT Trainings', stats.itTrainings], [''], ['Generated on:', new Date().toLocaleString()]
            ];
            const trainingData = filteredTrainings.map(training => {
                const timeInfo = getTrainingTimeInfo(training);
                let userName = training.trainerDisplayName || training.trainerName || 'Not Assigned';
                const startDateStr = format(new Date(training.trainingStartDate), 'dd/MM/yyyy');
                const endDateStr = format(new Date(training.trainingEndDate), 'dd/MM/yyyy');
                const dateRange = training.dateRange || getDateRangeString(training.trainingStartDate, training.trainingEndDate);
                return {
                    'Training Name': training.name || '-',
                    'Type': training.originalType || extractOriginalType(training.type),
                    'Date Range': dateRange || '-',
                    'Start Date': startDateStr, 'End Date': endDateStr,
                    'Depot': training.depot || '-', 'State': training.state || '-',
                    'Trainer': userName, 'Time': timeInfo.timeDisplay,
                    'Duration (Hours)': timeInfo.duration > 0 ? timeInfo.duration : '-',
                    'Status': training.status || 'N/A',
                    'Training Mode': training.trainingMode || 'N/A',
                    'Batch Plan': training.batchPlan || 'N/A'
                };
            });
            const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
            const wsTrainings = XLSX.utils.json_to_sheet(trainingData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, wsSummary, 'Summary');
            XLSX.utils.book_append_sheet(wb, wsTrainings, 'Training Details');
            XLSX.writeFile(wb, `training_calendar_${format(calendarDate, 'yyyy_MM')}.xlsx`);
            toast.success('Excel exported successfully!');
        } catch (error) {
            console.error("Excel export failed:", error);
            toast.error('Failed to export Excel');
        }
    };

    const handleShare = () => {
        setShareUrl(window.location.href);
        setShareDialogOpen(true);
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareUrl);
        setSnackbarMessage('Link copied to clipboard!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
    };

    const shareViaEmail = () => {
        const subject = `Training Calendar - ${format(calendarDate, 'MMMM yyyy')}`;
        const stats = getMonthlyStats();
        const body = `Training Calendar Summary:\n\nMonth: ${format(calendarDate, 'MMMM yyyy')}\nTotal: ${filteredTrainings.length}\nDriver: ${stats.driverTrainings}\nTechnical: ${stats.technicalTrainings}\nSafety: ${stats.safetyTrainings}\nIT: ${stats.itTrainings}\n\nView: ${shareUrl}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };

    const shareViaWhatsApp = () => {
        const stats = getMonthlyStats();
        const text = `Training Calendar - ${format(calendarDate, 'MMMM yyyy')}\nTotal: ${filteredTrainings.length}\nDriver: ${stats.driverTrainings}, Technical: ${stats.technicalTrainings}, Safety: ${stats.safetyTrainings}, IT: ${stats.itTrainings}\nView: ${shareUrl}`;
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
    };

    const handleDownloadPNG = async () => {
        if (!calendarRef.current) return;
        try {
            toast.info("Preparing PNG download...");
            const clone = calendarRef.current.cloneNode(true);
            const style = clone.ownerDocument.createElement('style');
            style.textContent = `
                .react-calendar { width: 100%; max-width: 1200px; background: white; border: 1px solid #747171; }
                .react-calendar__tile { min-height: 280px; text-align: left; padding: 8px 4px; background: white; }
                .training-card { background: white; border: 1px solid #7c7a7a; border-radius: 4px; padding: 8px; margin-bottom: 8px; font-size: 10px; color: #000000; }
            `;
            clone.prepend(style);
            const container = clone.ownerDocument.createElement('div');
            container.style.padding = '20px';
            container.style.backgroundColor = 'white';
            container.style.maxWidth = '1200px';
            const header = clone.ownerDocument.createElement('div');
            header.innerHTML = `
                <h1 style="text-align: center;">Training Calendar</h1>
                <div style="display: flex; justify-content: space-between; margin-bottom: 15px; padding: 10px; background: #f5f5f5;">
                    <div><strong>Month:</strong> ${format(calendarDate, 'MMMM yyyy')}</div>
                    <div><strong>Total:</strong> ${filteredTrainings.length}</div>
                </div>
            `;
            container.appendChild(header);
            container.appendChild(clone);
            document.body.appendChild(container);
            const canvas = await html2canvas(container, { backgroundColor: "#ffffff", scale: 2, useCORS: true });
            document.body.removeChild(container);
            const link = document.createElement("a");
            link.download = `training_calendar_${format(calendarDate, 'yyyy_MM')}.png`;
            link.href = canvas.toDataURL("image/png");
            link.click();
            toast.success('PNG downloaded successfully!');
        } catch (err) {
            console.error("Download failed:", err);
            toast.error('Failed to download PNG');
        }
    };

    useEffect(() => {
        return () => {
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, []);

    if (isDataLoading) {
        return (
            <Container sx={{ mt: 4, mb: 4 }}>
                <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                    <CircularProgress size={60} />
                    <Typography variant="h6" sx={{ mt: 2 }}>Loading Training Calendar...</Typography>
                </Paper>
            </Container>
        );
    }

    return (
        <Container ref={mainContainerRef} sx={{ mt: 4, mb: 4, maxWidth: '1400px !important' }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
                    <Box>
                        <Typography variant="h4" component="h1" gutterBottom>Training Calendar</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Role: <strong>{type || 'Guest'}</strong>
                            {userInfo.userName && <> | Name: <strong>{userInfo.userName}</strong></>}
                            {filteredTrainings.length > 0 && <> | Total: <strong>{filteredTrainings.length}</strong></>}
                        </Typography>
                    </Box>
                    <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
                        <Button variant="outlined" onClick={toggleTimeFormat} startIcon={<TwentyFourMpIcon />} size="small">
                            {use24HourFormat ? "24h" : "12h"}
                        </Button>
                        <Button variant="outlined" onClick={handlePrint} startIcon={<PrintIcon />} size="small">Print</Button>
                        <Button variant="outlined" onClick={handleShare} startIcon={<ShareIcon />} size="small">Share</Button>
                        <Button variant="contained" onClick={handleCopyToEmail} startIcon={<EmailCopyIcon />} size="small" color="info">Copy to Email</Button>
                        <Button variant="outlined" onClick={handleExportPDF} startIcon={<PictureAsPdfIcon />} size="small" color="error">PDF</Button>
                        <Button variant="outlined" onClick={handleExportExcel} startIcon={<TableChartIcon />} size="small" color="success">Excel</Button>
                        <Button variant="outlined" onClick={handleDownloadPNG} startIcon={<DownloadIcon />} size="small" color="primary">PNG</Button>
                        {userPermissions.canCreateTraining && (
                            <Button variant="contained" color="primary" onClick={() => setIsCreateModalOpen(true)} size="small">Create Training</Button>
                        )}
                    </Stack>
                </Stack>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>Filter by Training Type</Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
                        <Chip label="All Trainings" clickable color={!selectedTrainingType ? "primary" : "default"} onClick={() => setSelectedTrainingType(null)} />
                        {trainingTypes.map((type) => (
                            <Chip key={type.id} label={type.name} clickable
                                sx={{ backgroundColor: type.color, color: 'white' }}
                                onClick={() => setSelectedTrainingType(type)} />
                        ))}
                    </Stack>
                </Box>

                {(type === "Tata Project Manager" || type === "Tata Depot Manager") && (
                    <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                        <Typography variant="h6" gutterBottom>Depot Filter</Typography>
                        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" gap={2}>
                            <FormControl sx={{ minWidth: 250 }}>
                                <InputLabel>Select Depot</InputLabel>
                                <Select value={selectedDepot || ''} label="Select Depot" onChange={(e) => setSelectedDepot(e.target.value)}>
                                    <MenuItem value="">All Depots</MenuItem>
                                    {[...new Set([...availableDepots, ...allDepotOptions])].sort().map((depot) => (
                                        <MenuItem key={depot} value={depot}>{depot}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button variant="outlined" onClick={() => setSelectedDepot(null)}>Reset</Button>
                        </Stack>
                    </Box>
                )}

                <Alert severity="info" sx={{ mb: 2 }}>
                    <strong>📅 Calendar:</strong> {filteredTrainings.length} trainings for {format(calendarDate, 'MMMM yyyy')}.
                    <br /><strong>📌 Status:</strong> Each training shows Active/Cancelled/Postponed/Completed status.
                </Alert>

                <Box sx={{ display: 'flex', justifyContent: 'center', overflowX: 'auto' }}>
                    <div ref={calendarRef}>
                        <Calendar
                            onChange={setCalendarDate}
                            value={calendarDate}
                            onClickDay={handleDateClick}
                            tileContent={tileContent}
                            showNeighboringMonth={false}
                            prev2Label={null}
                            next2Label={null}
                            formatMonthYear={(locale, date) => format(date, 'MMMM yyyy')}
                            onActiveStartDateChange={handleActiveStartDateChange}
                            tileClassName={({ date, view }) => (view === 'month' && isWeekend(date)) ? 'weekend' : null}
                        />
                    </div>
                </Box>

                <TrainingDetailsModal
                    isOpen={isDetailsModalOpen}
                    onClose={() => setIsDetailsModalOpen(false)}
                    trainings={selectedDateTrainings}
                    onDeleteTraining={userPermissions.canDeleteTraining ? deleteTraining : null}
                    onGenerateBatch={handleGenerateBatch}
                    onUpdateTraining={handleUpdateTraining}
                    type={type}
                    userInfo={userInfo}
                />

                <CreateTrainingModal
                    isOpen={isCreateModalOpen}
                    onClose={() => setIsCreateModalOpen(false)}
                    onCreateTraining={createTraining}
                    allBatch={allBatch}
                    allTrainers={allUsers}
                    allCourseNames={allCourseNames}
                    loader={loader}
                />

                <Dialog open={shareDialogOpen} onClose={() => setShareDialogOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Share Calendar</DialogTitle>
                    <DialogContent>
                        <List>
                            <ListItem button onClick={copyToClipboard}>
                                <ListItemIcon><ContentCopyIcon /></ListItemIcon>
                                <ListItemText primary="Copy Link" />
                            </ListItem>
                            <Divider />
                            <ListItem button onClick={shareViaEmail}>
                                <ListItemIcon><EmailIcon /></ListItemIcon>
                                <ListItemText primary="Email" />
                            </ListItem>
                            <Divider />
                            <ListItem button onClick={shareViaWhatsApp}>
                                <ListItemIcon><WhatsAppIcon /></ListItemIcon>
                                <ListItemText primary="WhatsApp" />
                            </ListItem>
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShareDialogOpen(false)}>Close</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={copyEmailDialogOpen} onClose={() => setCopyEmailDialogOpen(false)} maxWidth="md" fullWidth>
                    <DialogTitle>Copy Calendar to Email</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                            Choose how to add the calendar to your email:
                        </Typography>
                        <List>
                            <ListItem button onClick={copyToClipboardEmail}>
                                <ListItemIcon><ContentCopyIcon sx={{ color: '#4caf50' }} /></ListItemIcon>
                                <ListItemText primary="Copy to Clipboard" secondary="Paste into Gmail/Outlook" />
                            </ListItem>
                            <Divider />
                            <ListItem button onClick={openEmailClient}>
                                <ListItemIcon><EmailIcon sx={{ color: '#2196f3' }} /></ListItemIcon>
                                <ListItemText primary="Open Email Client" />
                            </ListItem>
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setCopyEmailDialogOpen(false)}>Close</Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
                    <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Paper>
        </Container>
    );
};

export default TCalendar;